// ⚙️ 자동 생성된 파일 (퀸덤 + 뮤즈 + 홀릭)
export const queendomSigCards = [
  {
    "id": 1,
    "amount": 1000,
    "frontImages": [
      "/images/queendom/group01/1048.webp",
      "/images/queendom/group01/1058.webp",
      "/images/queendom/group01/1031.webp",
      "/images/queendom/group01/1036.webp",
      "/images/queendom/group01/1029.webp",
      "/images/queendom/group01/1079.webp",
      "/images/queendom/group01/1017.webp",
      "/images/queendom/group01/1080.webp",
      "/images/queendom/group01/1077.webp",
      "/images/queendom/group01/1015.webp",
      "/images/queendom/group01/1055.webp",
      "/images/queendom/group01/1008.webp",
      "/images/queendom/group01/1051.webp",
      "/images/queendom/group01/1092.webp",
      "/images/queendom/group01/1061.webp",
      "/images/queendom/group01/1019.webp",
      "/images/queendom/group01/1033.webp",
      "/images/queendom/group01/1081.webp",
      "/images/queendom/group01/1091.webp",
      "/images/queendom/group01/1026.webp",
      "/images/queendom/group01/1010.webp",
      "/images/queendom/group01/1060.webp",
      "/images/queendom/group01/1070.webp",
      "/images/queendom/group01/1003.webp",
      "/images/queendom/group01/1040.webp",
      "/images/queendom/group01/1006.webp",
      "/images/queendom/group01/1057.webp",
      "/images/queendom/group01/1054.webp",
      "/images/queendom/group01/1009.webp",
      "/images/queendom/group01/1028.webp",
      "/images/queendom/group01/1073.webp",
      "/images/queendom/group01/1085.webp",
      "/images/queendom/group01/1001.webp",
      "/images/queendom/group01/1083.webp",
      "/images/queendom/group01/1024.webp",
      "/images/queendom/group01/1027.webp",
      "/images/queendom/group01/1065.webp",
      "/images/queendom/group01/1030.webp",
      "/images/queendom/group01/1039.webp",
      "/images/queendom/group01/1045.webp",
      "/images/queendom/group01/1016.webp",
      "/images/queendom/group01/1088.webp",
      "/images/queendom/group01/1021.webp",
      "/images/queendom/group01/1002.webp",
      "/images/queendom/group01/1023.webp",
      "/images/queendom/group01/1067.webp",
      "/images/queendom/group01/1034.webp",
      "/images/queendom/group01/1037.webp",
      "/images/queendom/group01/1066.webp",
      "/images/queendom/group01/1049.webp",
      "/images/queendom/group01/1062.webp",
      "/images/queendom/group01/1012.webp",
      "/images/queendom/group01/1038.webp",
      "/images/queendom/group01/1044.webp",
      "/images/queendom/group01/1090.webp",
      "/images/queendom/group01/1047.webp",
      "/images/queendom/group01/1082.webp",
      "/images/queendom/group01/1025.webp",
      "/images/queendom/group01/1069.webp",
      "/images/queendom/group01/1042.webp",
      "/images/queendom/group01/1074.webp",
      "/images/queendom/group01/1056.webp",
      "/images/queendom/group01/1064.webp",
      "/images/queendom/group01/1011.webp",
      "/images/queendom/group01/1098.webp",
      "/images/queendom/group01/1007.webp",
      "/images/queendom/group01/1005.webp",
      "/images/queendom/group01/1015 예쁜 연아 나이 25살.png",
      "/images/queendom/group01/1094.webp",
      "/images/queendom/group01/1087.webp",
      "/images/queendom/group01/1095.webp",
      "/images/queendom/group01/1013.webp",
      "/images/queendom/group01/1041.webp",
      "/images/queendom/group01/1086.webp",
      "/images/queendom/group01/1078.webp",
      "/images/queendom/group01/1032.webp",
      "/images/queendom/group01/1053.webp",
      "/images/queendom/group01/1052.webp",
      "/images/queendom/group01/1096.webp",
      "/images/queendom/group01/1097.webp",
      "/images/queendom/group01/1000.webp",
      "/images/queendom/group01/1020.webp",
      "/images/queendom/group01/1075.webp",
      "/images/queendom/group01/1050.webp",
      "/images/queendom/group01/1014.webp",
      "/images/queendom/group01/1084.webp",
      "/images/queendom/group01/1046.webp",
      "/images/queendom/group01/1089.webp",
      "/images/queendom/group01/1072.webp",
      "/images/queendom/group01/1063.webp",
      "/images/queendom/group01/1068.webp",
      "/images/queendom/group01/1004.webp",
      "/images/queendom/group01/1076.webp",
      "/images/queendom/group01/1093.webp",
      "/images/queendom/group01/1022.webp",
      "/images/queendom/group01/1035.webp",
      "/images/queendom/group01/1018.webp",
      "/images/queendom/group01/1071.webp",
      "/images/queendom/group01/1059.webp",
      "/images/queendom/group01/1043.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 2,
    "amount": 2000,
    "frontImages": [
      "/images/queendom/group02/1101.webp",
      "/images/queendom/group05/5002.webp",
      "/images/queendom/group02/1103.webp",
      "/images/queendom/group03/1345.webp",
      "/images/queendom/group01/1001.webp",
      "/images/queendom/group04/3070.webp",
      "/images/queendom/group05/8282.webp",
      "/images/queendom/group04/2060.webp",
      "/images/queendom/group04/2400.webp",
      "/images/queendom/group02/1180.webp",
      "/images/queendom/group01/1100.webp",
      "/images/queendom/group02/1126.webp",
      "/images/queendom/group02/1123.webp",
      "/images/queendom/group04/2720.webp",
      "/images/queendom/group02/1107.webp",
      "/images/queendom/group03/1818.webp",
      "/images/queendom/group01/1000.webp",
      "/images/queendom/group04/2240.webp",
      "/images/queendom/group05/7700.webp",
      "/images/queendom/group04/3500.webp",
      "/images/queendom/group05/7007.webp",
      "/images/queendom/group04/3100.webp",
      "/images/queendom/group04/2600.webp",
      "/images/queendom/group02/1158.webp",
      "/images/queendom/group03/1999.webp",
      "/images/queendom/group02/1104.webp",
      "/images/queendom/group02/1131.webp",
      "/images/queendom/group04/2000.webp",
      "/images/queendom/group03/1520.webp",
      "/images/queendom/group02/1133.webp",
      "/images/queendom/group02/1124.webp",
      "/images/queendom/group03/1515.webp",
      "/images/queendom/group02/1105.webp",
      "/images/queendom/group03/1577.webp",
      "/images/queendom/group02/1110.webp",
      "/images/queendom/group02/1111.webp",
      "/images/queendom/group02/1270.webp",
      "/images/queendom/group03/1800.webp",
      "/images/queendom/group04/2230.webp",
      "/images/queendom/group04/2424.webp",
      "/images/queendom/group02/1128.webp",
      "/images/queendom/group04/3300.webp",
      "/images/queendom/group04/2828.webp",
      "/images/queendom/group01/1099.webp",
      "/images/queendom/group04/3333.webp",
      "/images/queendom/group02/1109.webp",
      "/images/queendom/group03/1400.webp",
      "/images/queendom/group02/1108.webp",
      "/images/queendom/group02/1132.webp",
      "/images/queendom/group02/1114.webp",
      "/images/queendom/group02/1250.webp",
      "/images/queendom/group03/1900.webp",
      "/images/queendom/group05/7000.webp",
      "/images/queendom/group05/6000.webp",
      "/images/queendom/group02/1106.webp",
      "/images/queendom/group02/1122.webp",
      "/images/queendom/group04/2900.webp",
      "/images/queendom/group03/1500.webp",
      "/images/queendom/group03/1300.webp",
      "/images/queendom/group02/1200.webp",
      "/images/queendom/group02/1234.webp",
      "/images/queendom/group02/1112.webp",
      "/images/queendom/group02/1120.webp",
      "/images/queendom/group02/1140.webp",
      "/images/queendom/group04/2190.webp",
      "/images/queendom/group02/1135.webp",
      "/images/queendom/group03/1501.webp",
      "/images/queendom/group02/1125.webp",
      "/images/queendom/group02/1113.webp",
      "/images/queendom/group04/3200.webp",
      "/images/queendom/group03/1777.webp",
      "/images/queendom/group04/2026.webp",
      "/images/queendom/group03/1560.webp",
      "/images/queendom/group05/7788.webp",
      "/images/queendom/group04/2150.webp",
      "/images/queendom/group02/1117.webp",
      "/images/queendom/group04/2099.webp",
      "/images/queendom/group05/6666.webp",
      "/images/queendom/group04/2054.webp",
      "/images/queendom/group04/2090.webp",
      "/images/queendom/group04/2111.webp",
      "/images/queendom/group04/3020.webp",
      "/images/queendom/group04/2210.webp",
      "/images/queendom/group04/2222.webp",
      "/images/queendom/group02/1115.webp",
      "/images/queendom/group03/1450.webp",
      "/images/queendom/group04/3000.webp",
      "/images/queendom/group02/1102.webp",
      "/images/queendom/group04/2050.webp",
      "/images/queendom/group02/1170.webp",
      "/images/queendom/group02/1121.webp",
      "/images/queendom/group04/2002.webp",
      "/images/queendom/group05/9000.webp",
      "/images/queendom/group04/3050.webp",
      "/images/queendom/group04/2290.webp",
      "/images/queendom/group02/1235.webp",
      "/images/queendom/group05/5000.webp",
      "/images/queendom/group05/7777.webp",
      "/images/queendom/group03/1350.webp",
      "/images/queendom/group02/1160.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 3,
    "amount": 3000,
    "frontImages": [
      "/images/queendom/group01/1007.webp",
      "/images/queendom/group01/1057.webp",
      "/images/queendom/group01/1015.webp",
      "/images/queendom/group01/1020.webp",
      "/images/queendom/group01/1060.webp",
      "/images/queendom/group01/1056.webp",
      "/images/queendom/group01/1069.webp",
      "/images/queendom/group01/1077.webp",
      "/images/queendom/group01/1046.webp",
      "/images/queendom/group01/1054.webp",
      "/images/queendom/group01/1029.webp",
      "/images/queendom/group01/1026.webp",
      "/images/queendom/group01/1068.webp",
      "/images/queendom/group01/1009.webp",
      "/images/queendom/group01/1095.webp",
      "/images/queendom/group01/1087.webp",
      "/images/queendom/group01/1006.webp",
      "/images/queendom/group01/1052.webp",
      "/images/queendom/group01/1037.webp",
      "/images/queendom/group01/1002.webp",
      "/images/queendom/group01/1058.webp",
      "/images/queendom/group01/1015 예쁜 연아 나이 25살.png",
      "/images/queendom/group01/1084.webp",
      "/images/queendom/group01/1011.webp",
      "/images/queendom/group01/1012.webp",
      "/images/queendom/group01/1010.webp",
      "/images/queendom/group01/1066.webp",
      "/images/queendom/group01/1064.webp",
      "/images/queendom/group01/1035.webp",
      "/images/queendom/group01/1080.webp",
      "/images/queendom/group01/1033.webp",
      "/images/queendom/group01/1074.webp",
      "/images/queendom/group01/1039.webp",
      "/images/queendom/group01/1063.webp",
      "/images/queendom/group01/1078.webp",
      "/images/queendom/group01/1059.webp",
      "/images/queendom/group01/1031.webp",
      "/images/queendom/group01/1032.webp",
      "/images/queendom/group01/1075.webp",
      "/images/queendom/group01/1062.webp",
      "/images/queendom/group01/1096.webp",
      "/images/queendom/group01/1049.webp",
      "/images/queendom/group01/1016.webp",
      "/images/queendom/group01/1014.webp",
      "/images/queendom/group01/1044.webp",
      "/images/queendom/group01/1065.webp",
      "/images/queendom/group01/1024.webp",
      "/images/queendom/group01/1081.webp",
      "/images/queendom/group01/1100.webp",
      "/images/queendom/group01/1088.webp",
      "/images/queendom/group01/1079.webp",
      "/images/queendom/group01/1098.webp",
      "/images/queendom/group01/1021.webp",
      "/images/queendom/group01/1076.webp",
      "/images/queendom/group01/1089.webp",
      "/images/queendom/group01/1083.webp",
      "/images/queendom/group01/1019.webp",
      "/images/queendom/group01/1038.webp",
      "/images/queendom/group01/1045.webp",
      "/images/queendom/group01/1036.webp",
      "/images/queendom/group01/1055.webp",
      "/images/queendom/group01/1061.webp",
      "/images/queendom/group01/1094.webp",
      "/images/queendom/group01/1005.webp",
      "/images/queendom/group01/1043.webp",
      "/images/queendom/group01/1048.webp",
      "/images/queendom/group01/1071.webp",
      "/images/queendom/group01/1092.webp",
      "/images/queendom/group01/1072.webp",
      "/images/queendom/group01/1091.webp",
      "/images/queendom/group01/1003.webp",
      "/images/queendom/group01/1053.webp",
      "/images/queendom/group01/1008.webp",
      "/images/queendom/group01/1082.webp",
      "/images/queendom/group01/1013.webp",
      "/images/queendom/group01/1040.webp",
      "/images/queendom/group01/1086.webp",
      "/images/queendom/group01/1027.webp",
      "/images/queendom/group01/1004.webp",
      "/images/queendom/group01/1030.webp",
      "/images/queendom/group01/1023.webp",
      "/images/queendom/group01/1067.webp",
      "/images/queendom/group01/1073.webp",
      "/images/queendom/group01/1085.webp",
      "/images/queendom/group01/1017.webp",
      "/images/queendom/group01/1047.webp",
      "/images/queendom/group01/1099.webp",
      "/images/queendom/group01/1042.webp",
      "/images/queendom/group01/1050.webp",
      "/images/queendom/group01/1090.webp",
      "/images/queendom/group01/1070.webp",
      "/images/queendom/group01/1025.webp",
      "/images/queendom/group01/1093.webp",
      "/images/queendom/group01/1097.webp",
      "/images/queendom/group01/1041.webp",
      "/images/queendom/group01/1051.webp",
      "/images/queendom/group01/1022.webp",
      "/images/queendom/group01/1034.webp",
      "/images/queendom/group01/1018.webp",
      "/images/queendom/group01/1028.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 4,
    "amount": 4000,
    "frontImages": [
      "/images/queendom/group04/3020.webp",
      "/images/queendom/group04/2222.webp",
      "/images/queendom/group02/1102.webp",
      "/images/queendom/group01/1000.webp",
      "/images/queendom/group02/1121.webp",
      "/images/queendom/group01/1002.webp",
      "/images/queendom/group05/7777.webp",
      "/images/queendom/group02/1200.webp",
      "/images/queendom/group04/2150.webp",
      "/images/queendom/group02/1128.webp",
      "/images/queendom/group05/7788.webp",
      "/images/queendom/group02/1122.webp",
      "/images/queendom/group02/1107.webp",
      "/images/queendom/group04/2210.webp",
      "/images/queendom/group04/2240.webp",
      "/images/queendom/group05/6666.webp",
      "/images/queendom/group02/1270.webp",
      "/images/queendom/group05/5002.webp",
      "/images/queendom/group04/2900.webp",
      "/images/queendom/group04/2190.webp",
      "/images/queendom/group05/6000.webp",
      "/images/queendom/group02/1131.webp",
      "/images/queendom/group04/3000.webp",
      "/images/queendom/group02/1160.webp",
      "/images/queendom/group02/1125.webp",
      "/images/queendom/group02/1126.webp",
      "/images/queendom/group02/1112.webp",
      "/images/queendom/group03/1501.webp",
      "/images/queendom/group01/1003.webp",
      "/images/queendom/group02/1250.webp",
      "/images/queendom/group02/1106.webp",
      "/images/queendom/group02/1117.webp",
      "/images/queendom/group05/9000.webp",
      "/images/queendom/group04/2026.webp",
      "/images/queendom/group04/2828.webp",
      "/images/queendom/group04/3500.webp",
      "/images/queendom/group04/2290.webp",
      "/images/queendom/group04/2230.webp",
      "/images/queendom/group03/1515.webp",
      "/images/queendom/group04/3333.webp",
      "/images/queendom/group04/3050.webp",
      "/images/queendom/group04/2099.webp",
      "/images/queendom/group04/2050.webp",
      "/images/queendom/group02/1108.webp",
      "/images/queendom/group02/1140.webp",
      "/images/queendom/group03/1800.webp",
      "/images/queendom/group02/1110.webp",
      "/images/queendom/group02/1109.webp",
      "/images/queendom/group04/2424.webp",
      "/images/queendom/group02/1103.webp",
      "/images/queendom/group04/3300.webp",
      "/images/queendom/group03/1560.webp",
      "/images/queendom/group02/1105.webp",
      "/images/queendom/group02/1113.webp",
      "/images/queendom/group02/1114.webp",
      "/images/queendom/group03/1900.webp",
      "/images/queendom/group02/1120.webp",
      "/images/queendom/group04/2000.webp",
      "/images/queendom/group04/2720.webp",
      "/images/queendom/group04/3100.webp",
      "/images/queendom/group04/2111.webp",
      "/images/queendom/group05/7700.webp",
      "/images/queendom/group03/1500.webp",
      "/images/queendom/group03/1777.webp",
      "/images/queendom/group04/3070.webp",
      "/images/queendom/group03/1818.webp",
      "/images/queendom/group02/1235.webp",
      "/images/queendom/group02/1104.webp",
      "/images/queendom/group04/2060.webp",
      "/images/queendom/group05/7000.webp",
      "/images/queendom/group03/1350.webp",
      "/images/queendom/group04/2002.webp",
      "/images/queendom/group02/1111.webp",
      "/images/queendom/group03/1999.webp",
      "/images/queendom/group02/1180.webp",
      "/images/queendom/group04/2600.webp",
      "/images/queendom/group02/1170.webp",
      "/images/queendom/group05/7007.webp",
      "/images/queendom/group02/1123.webp",
      "/images/queendom/group01/1001.webp",
      "/images/queendom/group03/1450.webp",
      "/images/queendom/group03/1577.webp",
      "/images/queendom/group04/2400.webp",
      "/images/queendom/group02/1234.webp",
      "/images/queendom/group05/5000.webp",
      "/images/queendom/group03/1400.webp",
      "/images/queendom/group04/2090.webp",
      "/images/queendom/group03/1345.webp",
      "/images/queendom/group04/3200.webp",
      "/images/queendom/group02/1135.webp",
      "/images/queendom/group05/8282.webp",
      "/images/queendom/group02/1115.webp",
      "/images/queendom/group02/1133.webp",
      "/images/queendom/group02/1158.webp",
      "/images/queendom/group02/1101.webp",
      "/images/queendom/group03/1520.webp",
      "/images/queendom/group02/1132.webp",
      "/images/queendom/group03/1300.webp",
      "/images/queendom/group04/2054.webp",
      "/images/queendom/group02/1124.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 5,
    "amount": 5000,
    "frontImages": [
      "/images/queendom/group01/1023.webp",
      "/images/queendom/group01/1044.webp",
      "/images/queendom/group01/1008.webp",
      "/images/queendom/group01/1010.webp",
      "/images/queendom/group01/1016.webp",
      "/images/queendom/group01/1070.webp",
      "/images/queendom/group01/1031.webp",
      "/images/queendom/group01/1075.webp",
      "/images/queendom/group01/1098.webp",
      "/images/queendom/group01/1078.webp",
      "/images/queendom/group01/1014.webp",
      "/images/queendom/group01/1067.webp",
      "/images/queendom/group01/1015 예쁜 연아 나이 25살.png",
      "/images/queendom/group01/1088.webp",
      "/images/queendom/group01/1060.webp",
      "/images/queendom/group01/1062.webp",
      "/images/queendom/group01/1046.webp",
      "/images/queendom/group01/1083.webp",
      "/images/queendom/group01/1005.webp",
      "/images/queendom/group01/1056.webp",
      "/images/queendom/group01/1080.webp",
      "/images/queendom/group01/1055.webp",
      "/images/queendom/group01/1077.webp",
      "/images/queendom/group01/1038.webp",
      "/images/queendom/group01/1066.webp",
      "/images/queendom/group01/1019.webp",
      "/images/queendom/group01/1061.webp",
      "/images/queendom/group01/1057.webp",
      "/images/queendom/group01/1095.webp",
      "/images/queendom/group01/1068.webp",
      "/images/queendom/group01/1079.webp",
      "/images/queendom/group01/1015.webp",
      "/images/queendom/group02/1101.webp",
      "/images/queendom/group01/1065.webp",
      "/images/queendom/group01/1087.webp",
      "/images/queendom/group01/1059.webp",
      "/images/queendom/group01/1092.webp",
      "/images/queendom/group01/1004.webp",
      "/images/queendom/group01/1032.webp",
      "/images/queendom/group01/1049.webp",
      "/images/queendom/group01/1030.webp",
      "/images/queendom/group01/1048.webp",
      "/images/queendom/group02/1102.webp",
      "/images/queendom/group01/1007.webp",
      "/images/queendom/group01/1047.webp",
      "/images/queendom/group01/1050.webp",
      "/images/queendom/group01/1071.webp",
      "/images/queendom/group01/1017.webp",
      "/images/queendom/group01/1063.webp",
      "/images/queendom/group01/1037.webp",
      "/images/queendom/group01/1034.webp",
      "/images/queendom/group01/1073.webp",
      "/images/queendom/group01/1011.webp",
      "/images/queendom/group01/1086.webp",
      "/images/queendom/group01/1026.webp",
      "/images/queendom/group01/1021.webp",
      "/images/queendom/group01/1058.webp",
      "/images/queendom/group01/1012.webp",
      "/images/queendom/group01/1052.webp",
      "/images/queendom/group01/1082.webp",
      "/images/queendom/group01/1042.webp",
      "/images/queendom/group01/1094.webp",
      "/images/queendom/group01/1096.webp",
      "/images/queendom/group01/1099.webp",
      "/images/queendom/group01/1040.webp",
      "/images/queendom/group01/1006.webp",
      "/images/queendom/group01/1018.webp",
      "/images/queendom/group01/1022.webp",
      "/images/queendom/group01/1041.webp",
      "/images/queendom/group01/1072.webp",
      "/images/queendom/group01/1039.webp",
      "/images/queendom/group01/1024.webp",
      "/images/queendom/group01/1045.webp",
      "/images/queendom/group01/1051.webp",
      "/images/queendom/group01/1090.webp",
      "/images/queendom/group01/1028.webp",
      "/images/queendom/group01/1020.webp",
      "/images/queendom/group01/1069.webp",
      "/images/queendom/group01/1089.webp",
      "/images/queendom/group01/1074.webp",
      "/images/queendom/group01/1085.webp",
      "/images/queendom/group01/1043.webp",
      "/images/queendom/group01/1064.webp",
      "/images/queendom/group01/1009.webp",
      "/images/queendom/group01/1035.webp",
      "/images/queendom/group01/1084.webp",
      "/images/queendom/group01/1025.webp",
      "/images/queendom/group01/1029.webp",
      "/images/queendom/group01/1091.webp",
      "/images/queendom/group01/1097.webp",
      "/images/queendom/group01/1033.webp",
      "/images/queendom/group01/1093.webp",
      "/images/queendom/group01/1036.webp",
      "/images/queendom/group01/1100.webp",
      "/images/queendom/group01/1076.webp",
      "/images/queendom/group01/1053.webp",
      "/images/queendom/group01/1027.webp",
      "/images/queendom/group01/1081.webp",
      "/images/queendom/group01/1054.webp",
      "/images/queendom/group01/1013.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 6,
    "amount": 6000,
    "frontImages": [
      "/images/queendom/group04/2600.webp",
      "/images/queendom/group04/2090.webp",
      "/images/queendom/group01/1001.webp",
      "/images/queendom/group05/7700.webp",
      "/images/queendom/group04/3070.webp",
      "/images/queendom/group02/1234.webp",
      "/images/queendom/group04/3333.webp",
      "/images/queendom/group03/1520.webp",
      "/images/queendom/group02/1124.webp",
      "/images/queendom/group02/1200.webp",
      "/images/queendom/group04/2111.webp",
      "/images/queendom/group02/1120.webp",
      "/images/queendom/group04/2050.webp",
      "/images/queendom/group02/1111.webp",
      "/images/queendom/group04/2828.webp",
      "/images/queendom/group02/1114.webp",
      "/images/queendom/group02/1250.webp",
      "/images/queendom/group04/2060.webp",
      "/images/queendom/group03/1345.webp",
      "/images/queendom/group03/1500.webp",
      "/images/queendom/group02/1235.webp",
      "/images/queendom/group05/8282.webp",
      "/images/queendom/group05/9000.webp",
      "/images/queendom/group02/1117.webp",
      "/images/queendom/group03/1777.webp",
      "/images/queendom/group05/7000.webp",
      "/images/queendom/group03/1900.webp",
      "/images/queendom/group04/2190.webp",
      "/images/queendom/group05/6000.webp",
      "/images/queendom/group04/2900.webp",
      "/images/queendom/group02/1133.webp",
      "/images/queendom/group01/1005.webp",
      "/images/queendom/group02/1131.webp",
      "/images/queendom/group02/1112.webp",
      "/images/queendom/group04/2000.webp",
      "/images/queendom/group01/1004.webp",
      "/images/queendom/group02/1132.webp",
      "/images/queendom/group04/3200.webp",
      "/images/queendom/group03/1300.webp",
      "/images/queendom/group02/1103.webp",
      "/images/queendom/group04/2230.webp",
      "/images/queendom/group05/7007.webp",
      "/images/queendom/group03/1350.webp",
      "/images/queendom/group04/3300.webp",
      "/images/queendom/group04/2054.webp",
      "/images/queendom/group01/1003.webp",
      "/images/queendom/group02/1180.webp",
      "/images/queendom/group03/1400.webp",
      "/images/queendom/group04/2720.webp",
      "/images/queendom/group04/2002.webp",
      "/images/queendom/group03/1515.webp",
      "/images/queendom/group02/1158.webp",
      "/images/queendom/group02/1135.webp",
      "/images/queendom/group02/1110.webp",
      "/images/queendom/group03/1577.webp",
      "/images/queendom/group02/1125.webp",
      "/images/queendom/group03/1800.webp",
      "/images/queendom/group02/1104.webp",
      "/images/queendom/group02/1122.webp",
      "/images/queendom/group04/2026.webp",
      "/images/queendom/group02/1126.webp",
      "/images/queendom/group02/1123.webp",
      "/images/queendom/group02/1107.webp",
      "/images/queendom/group02/1108.webp",
      "/images/queendom/group04/2210.webp",
      "/images/queendom/group04/2099.webp",
      "/images/queendom/group02/1270.webp",
      "/images/queendom/group02/1113.webp",
      "/images/queendom/group04/3500.webp",
      "/images/queendom/group04/3000.webp",
      "/images/queendom/group04/2222.webp",
      "/images/queendom/group04/2290.webp",
      "/images/queendom/group02/1115.webp",
      "/images/queendom/group01/1002.webp",
      "/images/queendom/group04/2424.webp",
      "/images/queendom/group05/7777.webp",
      "/images/queendom/group03/1818.webp",
      "/images/queendom/group02/1140.webp",
      "/images/queendom/group02/1106.webp",
      "/images/queendom/group05/6666.webp",
      "/images/queendom/group04/2150.webp",
      "/images/queendom/group02/1121.webp",
      "/images/queendom/group01/1000.webp",
      "/images/queendom/group04/3100.webp",
      "/images/queendom/group03/1450.webp",
      "/images/queendom/group04/2240.webp",
      "/images/queendom/group03/1560.webp",
      "/images/queendom/group02/1128.webp",
      "/images/queendom/group03/1501.webp",
      "/images/queendom/group04/3020.webp",
      "/images/queendom/group04/2400.webp",
      "/images/queendom/group02/1160.webp",
      "/images/queendom/group02/1105.webp",
      "/images/queendom/group05/5000.webp",
      "/images/queendom/group02/1170.webp",
      "/images/queendom/group05/7788.webp",
      "/images/queendom/group04/3050.webp",
      "/images/queendom/group02/1109.webp",
      "/images/queendom/group05/5002.webp",
      "/images/queendom/group03/1999.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 7,
    "amount": 7000,
    "frontImages": [
      "/images/queendom/group01/1014.webp",
      "/images/queendom/group01/1042.webp",
      "/images/queendom/group01/1062.webp",
      "/images/queendom/group02/1101.webp",
      "/images/queendom/group01/1094.webp",
      "/images/queendom/group01/1086.webp",
      "/images/queendom/group01/1017.webp",
      "/images/queendom/group01/1072.webp",
      "/images/queendom/group01/1090.webp",
      "/images/queendom/group01/1023.webp",
      "/images/queendom/group01/1048.webp",
      "/images/queendom/group01/1029.webp",
      "/images/queendom/group02/1103.webp",
      "/images/queendom/group01/1030.webp",
      "/images/queendom/group01/1034.webp",
      "/images/queendom/group01/1078.webp",
      "/images/queendom/group01/1098.webp",
      "/images/queendom/group01/1100.webp",
      "/images/queendom/group01/1026.webp",
      "/images/queendom/group01/1032.webp",
      "/images/queendom/group01/1092.webp",
      "/images/queendom/group01/1051.webp",
      "/images/queendom/group01/1018.webp",
      "/images/queendom/group01/1056.webp",
      "/images/queendom/group01/1069.webp",
      "/images/queendom/group01/1050.webp",
      "/images/queendom/group01/1099.webp",
      "/images/queendom/group01/1058.webp",
      "/images/queendom/group01/1074.webp",
      "/images/queendom/group01/1054.webp",
      "/images/queendom/group01/1075.webp",
      "/images/queendom/group01/1063.webp",
      "/images/queendom/group01/1038.webp",
      "/images/queendom/group01/1073.webp",
      "/images/queendom/group01/1049.webp",
      "/images/queendom/group01/1087.webp",
      "/images/queendom/group01/1033.webp",
      "/images/queendom/group01/1088.webp",
      "/images/queendom/group01/1091.webp",
      "/images/queendom/group01/1081.webp",
      "/images/queendom/group02/1104.webp",
      "/images/queendom/group01/1044.webp",
      "/images/queendom/group01/1011.webp",
      "/images/queendom/group01/1070.webp",
      "/images/queendom/group01/1067.webp",
      "/images/queendom/group01/1020.webp",
      "/images/queendom/group01/1008.webp",
      "/images/queendom/group01/1016.webp",
      "/images/queendom/group02/1102.webp",
      "/images/queendom/group01/1010.webp",
      "/images/queendom/group01/1089.webp",
      "/images/queendom/group01/1024.webp",
      "/images/queendom/group01/1027.webp",
      "/images/queendom/group01/1059.webp",
      "/images/queendom/group01/1040.webp",
      "/images/queendom/group01/1035.webp",
      "/images/queendom/group01/1097.webp",
      "/images/queendom/group01/1021.webp",
      "/images/queendom/group01/1085.webp",
      "/images/queendom/group01/1053.webp",
      "/images/queendom/group01/1009.webp",
      "/images/queendom/group01/1076.webp",
      "/images/queendom/group01/1065.webp",
      "/images/queendom/group01/1025.webp",
      "/images/queendom/group01/1015.webp",
      "/images/queendom/group01/1077.webp",
      "/images/queendom/group01/1061.webp",
      "/images/queendom/group01/1096.webp",
      "/images/queendom/group01/1046.webp",
      "/images/queendom/group01/1052.webp",
      "/images/queendom/group01/1080.webp",
      "/images/queendom/group01/1057.webp",
      "/images/queendom/group01/1079.webp",
      "/images/queendom/group01/1045.webp",
      "/images/queendom/group01/1007.webp",
      "/images/queendom/group01/1047.webp",
      "/images/queendom/group01/1031.webp",
      "/images/queendom/group01/1095.webp",
      "/images/queendom/group01/1084.webp",
      "/images/queendom/group01/1055.webp",
      "/images/queendom/group01/1071.webp",
      "/images/queendom/group01/1060.webp",
      "/images/queendom/group01/1083.webp",
      "/images/queendom/group01/1013.webp",
      "/images/queendom/group01/1036.webp",
      "/images/queendom/group01/1039.webp",
      "/images/queendom/group01/1041.webp",
      "/images/queendom/group01/1066.webp",
      "/images/queendom/group01/1043.webp",
      "/images/queendom/group01/1006.webp",
      "/images/queendom/group01/1068.webp",
      "/images/queendom/group01/1015 예쁜 연아 나이 25살.png",
      "/images/queendom/group01/1022.webp",
      "/images/queendom/group01/1037.webp",
      "/images/queendom/group01/1082.webp",
      "/images/queendom/group01/1093.webp",
      "/images/queendom/group01/1019.webp",
      "/images/queendom/group01/1028.webp",
      "/images/queendom/group01/1012.webp",
      "/images/queendom/group01/1064.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 8,
    "amount": 8000,
    "frontImages": [
      "/images/queendom/group04/2424.webp",
      "/images/queendom/group02/1135.webp",
      "/images/queendom/group05/5000.webp",
      "/images/queendom/group02/1132.webp",
      "/images/queendom/group04/2050.webp",
      "/images/queendom/group04/2900.webp",
      "/images/queendom/group02/1131.webp",
      "/images/queendom/group04/3333.webp",
      "/images/queendom/group04/3020.webp",
      "/images/queendom/group02/1105.webp",
      "/images/queendom/group04/2000.webp",
      "/images/queendom/group02/1180.webp",
      "/images/queendom/group04/3200.webp",
      "/images/queendom/group02/1158.webp",
      "/images/queendom/group02/1140.webp",
      "/images/queendom/group02/1270.webp",
      "/images/queendom/group02/1234.webp",
      "/images/queendom/group02/1200.webp",
      "/images/queendom/group01/1005.webp",
      "/images/queendom/group03/1300.webp",
      "/images/queendom/group04/3070.webp",
      "/images/queendom/group02/1115.webp",
      "/images/queendom/group04/2054.webp",
      "/images/queendom/group04/2400.webp",
      "/images/queendom/group02/1250.webp",
      "/images/queendom/group02/1122.webp",
      "/images/queendom/group04/2230.webp",
      "/images/queendom/group02/1125.webp",
      "/images/queendom/group04/2828.webp",
      "/images/queendom/group04/3100.webp",
      "/images/queendom/group04/3050.webp",
      "/images/queendom/group02/1124.webp",
      "/images/queendom/group05/7700.webp",
      "/images/queendom/group04/2290.webp",
      "/images/queendom/group05/8282.webp",
      "/images/queendom/group02/1160.webp",
      "/images/queendom/group04/2190.webp",
      "/images/queendom/group05/7000.webp",
      "/images/queendom/group04/3300.webp",
      "/images/queendom/group02/1113.webp",
      "/images/queendom/group02/1126.webp",
      "/images/queendom/group05/6000.webp",
      "/images/queendom/group03/1515.webp",
      "/images/queendom/group05/6666.webp",
      "/images/queendom/group02/1120.webp",
      "/images/queendom/group03/1350.webp",
      "/images/queendom/group02/1110.webp",
      "/images/queendom/group03/1400.webp",
      "/images/queendom/group03/1818.webp",
      "/images/queendom/group01/1000.webp",
      "/images/queendom/group03/1345.webp",
      "/images/queendom/group04/2099.webp",
      "/images/queendom/group02/1235.webp",
      "/images/queendom/group03/1999.webp",
      "/images/queendom/group02/1106.webp",
      "/images/queendom/group03/1577.webp",
      "/images/queendom/group03/1520.webp",
      "/images/queendom/group04/2060.webp",
      "/images/queendom/group04/2210.webp",
      "/images/queendom/group01/1006.webp",
      "/images/queendom/group03/1900.webp",
      "/images/queendom/group03/1501.webp",
      "/images/queendom/group02/1109.webp",
      "/images/queendom/group04/2720.webp",
      "/images/queendom/group04/3500.webp",
      "/images/queendom/group04/2111.webp",
      "/images/queendom/group02/1170.webp",
      "/images/queendom/group02/1128.webp",
      "/images/queendom/group04/2002.webp",
      "/images/queendom/group05/7007.webp",
      "/images/queendom/group02/1133.webp",
      "/images/queendom/group02/1117.webp",
      "/images/queendom/group04/2150.webp",
      "/images/queendom/group04/2240.webp",
      "/images/queendom/group05/5002.webp",
      "/images/queendom/group04/3000.webp",
      "/images/queendom/group05/9000.webp",
      "/images/queendom/group01/1002.webp",
      "/images/queendom/group04/2090.webp",
      "/images/queendom/group01/1001.webp",
      "/images/queendom/group03/1500.webp",
      "/images/queendom/group03/1450.webp",
      "/images/queendom/group03/1800.webp",
      "/images/queendom/group01/1004.webp",
      "/images/queendom/group02/1107.webp",
      "/images/queendom/group05/7777.webp",
      "/images/queendom/group04/2222.webp",
      "/images/queendom/group02/1114.webp",
      "/images/queendom/group02/1112.webp",
      "/images/queendom/group03/1560.webp",
      "/images/queendom/group04/2026.webp",
      "/images/queendom/group02/1108.webp",
      "/images/queendom/group03/1777.webp",
      "/images/queendom/group02/1123.webp",
      "/images/queendom/group01/1007.webp",
      "/images/queendom/group04/2600.webp",
      "/images/queendom/group01/1003.webp",
      "/images/queendom/group02/1111.webp",
      "/images/queendom/group02/1121.webp",
      "/images/queendom/group05/7788.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 9,
    "amount": 9000,
    "frontImages": [
      "/images/queendom/group01/1021.webp",
      "/images/queendom/group01/1011.webp",
      "/images/queendom/group01/1015.webp",
      "/images/queendom/group01/1044.webp",
      "/images/queendom/group01/1052.webp",
      "/images/queendom/group01/1075.webp",
      "/images/queendom/group01/1097.webp",
      "/images/queendom/group01/1029.webp",
      "/images/queendom/group01/1077.webp",
      "/images/queendom/group01/1042.webp",
      "/images/queendom/group01/1031.webp",
      "/images/queendom/group01/1056.webp",
      "/images/queendom/group01/1051.webp",
      "/images/queendom/group01/1034.webp",
      "/images/queendom/group01/1070.webp",
      "/images/queendom/group01/1035.webp",
      "/images/queendom/group01/1068.webp",
      "/images/queendom/group01/1063.webp",
      "/images/queendom/group01/1062.webp",
      "/images/queendom/group01/1071.webp",
      "/images/queendom/group02/1105.webp",
      "/images/queendom/group01/1015 예쁜 연아 나이 25살.png",
      "/images/queendom/group01/1024.webp",
      "/images/queendom/group01/1089.webp",
      "/images/queendom/group01/1065.webp",
      "/images/queendom/group02/1101.webp",
      "/images/queendom/group01/1090.webp",
      "/images/queendom/group01/1039.webp",
      "/images/queendom/group01/1054.webp",
      "/images/queendom/group01/1073.webp",
      "/images/queendom/group01/1040.webp",
      "/images/queendom/group01/1088.webp",
      "/images/queendom/group01/1083.webp",
      "/images/queendom/group01/1047.webp",
      "/images/queendom/group01/1095.webp",
      "/images/queendom/group01/1033.webp",
      "/images/queendom/group01/1043.webp",
      "/images/queendom/group01/1053.webp",
      "/images/queendom/group01/1030.webp",
      "/images/queendom/group01/1087.webp",
      "/images/queendom/group01/1082.webp",
      "/images/queendom/group02/1106.webp",
      "/images/queendom/group01/1045.webp",
      "/images/queendom/group01/1025.webp",
      "/images/queendom/group01/1081.webp",
      "/images/queendom/group01/1080.webp",
      "/images/queendom/group01/1055.webp",
      "/images/queendom/group01/1016.webp",
      "/images/queendom/group01/1008.webp",
      "/images/queendom/group01/1017.webp",
      "/images/queendom/group02/1103.webp",
      "/images/queendom/group01/1092.webp",
      "/images/queendom/group01/1023.webp",
      "/images/queendom/group01/1099.webp",
      "/images/queendom/group01/1059.webp",
      "/images/queendom/group01/1027.webp",
      "/images/queendom/group01/1013.webp",
      "/images/queendom/group01/1032.webp",
      "/images/queendom/group01/1067.webp",
      "/images/queendom/group01/1093.webp",
      "/images/queendom/group01/1036.webp",
      "/images/queendom/group01/1026.webp",
      "/images/queendom/group01/1057.webp",
      "/images/queendom/group01/1041.webp",
      "/images/queendom/group01/1018.webp",
      "/images/queendom/group01/1078.webp",
      "/images/queendom/group01/1038.webp",
      "/images/queendom/group01/1064.webp",
      "/images/queendom/group01/1100.webp",
      "/images/queendom/group01/1061.webp",
      "/images/queendom/group01/1096.webp",
      "/images/queendom/group01/1049.webp",
      "/images/queendom/group01/1069.webp",
      "/images/queendom/group01/1020.webp",
      "/images/queendom/group01/1046.webp",
      "/images/queendom/group01/1010.webp",
      "/images/queendom/group01/1058.webp",
      "/images/queendom/group01/1079.webp",
      "/images/queendom/group01/1048.webp",
      "/images/queendom/group01/1019.webp",
      "/images/queendom/group01/1085.webp",
      "/images/queendom/group01/1012.webp",
      "/images/queendom/group01/1028.webp",
      "/images/queendom/group01/1066.webp",
      "/images/queendom/group01/1086.webp",
      "/images/queendom/group01/1091.webp",
      "/images/queendom/group01/1009.webp",
      "/images/queendom/group01/1072.webp",
      "/images/queendom/group01/1060.webp",
      "/images/queendom/group01/1098.webp",
      "/images/queendom/group01/1014.webp",
      "/images/queendom/group01/1076.webp",
      "/images/queendom/group01/1022.webp",
      "/images/queendom/group01/1050.webp",
      "/images/queendom/group02/1102.webp",
      "/images/queendom/group02/1104.webp",
      "/images/queendom/group01/1084.webp",
      "/images/queendom/group01/1074.webp",
      "/images/queendom/group01/1094.webp",
      "/images/queendom/group01/1037.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 10,
    "amount": 10000,
    "frontImages": [
      "/images/queendom/group04/2002.webp",
      "/images/queendom/group04/2190.webp",
      "/images/queendom/group01/1009.webp",
      "/images/queendom/group02/1140.webp",
      "/images/queendom/group02/1235.webp",
      "/images/queendom/group01/1006.webp",
      "/images/queendom/group04/2060.webp",
      "/images/queendom/group04/2099.webp",
      "/images/queendom/group04/2026.webp",
      "/images/queendom/group02/1115.webp",
      "/images/queendom/group02/1125.webp",
      "/images/queendom/group05/5002.webp",
      "/images/queendom/group02/1113.webp",
      "/images/queendom/group04/2828.webp",
      "/images/queendom/group02/1132.webp",
      "/images/queendom/group03/1777.webp",
      "/images/queendom/group02/1234.webp",
      "/images/queendom/group04/2900.webp",
      "/images/queendom/group05/7777.webp",
      "/images/queendom/group02/1158.webp",
      "/images/queendom/group03/1300.webp",
      "/images/queendom/group02/1123.webp",
      "/images/queendom/group03/1450.webp",
      "/images/queendom/group01/1005.webp",
      "/images/queendom/group01/1008.webp",
      "/images/queendom/group01/1002.webp",
      "/images/queendom/group05/7700.webp",
      "/images/queendom/group02/1135.webp",
      "/images/queendom/group02/1250.webp",
      "/images/queendom/group02/1270.webp",
      "/images/queendom/group01/1004.webp",
      "/images/queendom/group03/1577.webp",
      "/images/queendom/group04/3300.webp",
      "/images/queendom/group04/2240.webp",
      "/images/queendom/group03/1520.webp",
      "/images/queendom/group02/1133.webp",
      "/images/queendom/group03/1350.webp",
      "/images/queendom/group05/7000.webp",
      "/images/queendom/group02/1117.webp",
      "/images/queendom/group01/1000.webp",
      "/images/queendom/group03/1345.webp",
      "/images/queendom/group04/2230.webp",
      "/images/queendom/group04/2424.webp",
      "/images/queendom/group05/7788.webp",
      "/images/queendom/group04/3200.webp",
      "/images/queendom/group04/2600.webp",
      "/images/queendom/group02/1170.webp",
      "/images/queendom/group03/1560.webp",
      "/images/queendom/group01/1001.webp",
      "/images/queendom/group02/1107.webp",
      "/images/queendom/group04/3500.webp",
      "/images/queendom/group02/1112.webp",
      "/images/queendom/group05/7007.webp",
      "/images/queendom/group04/2090.webp",
      "/images/queendom/group04/2111.webp",
      "/images/queendom/group04/2210.webp",
      "/images/queendom/group02/1110.webp",
      "/images/queendom/group03/1515.webp",
      "/images/queendom/group01/1003.webp",
      "/images/queendom/group05/9000.webp",
      "/images/queendom/group04/2150.webp",
      "/images/queendom/group02/1126.webp",
      "/images/queendom/group04/2222.webp",
      "/images/queendom/group04/3050.webp",
      "/images/queendom/group03/1500.webp",
      "/images/queendom/group01/1007.webp",
      "/images/queendom/group02/1120.webp",
      "/images/queendom/group05/6000.webp",
      "/images/queendom/group03/1818.webp",
      "/images/queendom/group04/3020.webp",
      "/images/queendom/group04/2050.webp",
      "/images/queendom/group04/3070.webp",
      "/images/queendom/group03/1999.webp",
      "/images/queendom/group04/3333.webp",
      "/images/queendom/group05/8282.webp",
      "/images/queendom/group02/1109.webp",
      "/images/queendom/group04/2000.webp",
      "/images/queendom/group02/1128.webp",
      "/images/queendom/group04/2054.webp",
      "/images/queendom/group03/1900.webp",
      "/images/queendom/group03/1400.webp",
      "/images/queendom/group04/2720.webp",
      "/images/queendom/group02/1114.webp",
      "/images/queendom/group02/1180.webp",
      "/images/queendom/group02/1124.webp",
      "/images/queendom/group02/1122.webp",
      "/images/queendom/group02/1160.webp",
      "/images/queendom/group02/1131.webp",
      "/images/queendom/group02/1108.webp",
      "/images/queendom/group04/3100.webp",
      "/images/queendom/group02/1200.webp",
      "/images/queendom/group04/2400.webp",
      "/images/queendom/group04/2290.webp",
      "/images/queendom/group02/1121.webp",
      "/images/queendom/group05/6666.webp",
      "/images/queendom/group04/3000.webp",
      "/images/queendom/group05/5000.webp",
      "/images/queendom/group02/1111.webp",
      "/images/queendom/group03/1501.webp",
      "/images/queendom/group03/1800.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 11,
    "amount": 50000,
    "frontImages": [
      "/images/queendom/group07/10545.webp",
      "/images/queendom/group07/10114.webp",
      "/images/queendom/group06/10024.webp",
      "/images/queendom/group06/10062.webp",
      "/images/queendom/group07/10445.webp",
      "/images/queendom/group07/10118.webp",
      "/images/queendom/group06/10155.webp",
      "/images/queendom/group07/10154.webp",
      "/images/queendom/group07/10224.webp",
      "/images/queendom/group06/10777.webp",
      "/images/queendom/group07/10098.webp",
      "/images/queendom/group07/11111.webp",
      "/images/queendom/group06/10076.webp",
      "/images/queendom/group06/10092.webp",
      "/images/queendom/group07/10100.webp",
      "/images/queendom/group07/10192.webp",
      "/images/queendom/group06/10068.webp",
      "/images/queendom/group07/10069.webp",
      "/images/queendom/group06/10057.webp",
      "/images/queendom/group06/10058.webp",
      "/images/queendom/group06/10044.webp",
      "/images/queendom/group07/10202.webp",
      "/images/queendom/group07/10972.webp",
      "/images/queendom/group06/10001.webp",
      "/images/queendom/group06/10083.webp",
      "/images/queendom/group06/10142.webp",
      "/images/queendom/group07/10163.webp",
      "/images/queendom/group06/10064.webp",
      "/images/queendom/group07/10401.webp",
      "/images/queendom/group06/10045.webp",
      "/images/queendom/group06/10011.webp",
      "/images/queendom/group07/10444.webp",
      "/images/queendom/group07/54321.webp",
      "/images/queendom/group06/10010.webp",
      "/images/queendom/group06/10009.webp",
      "/images/queendom/group07/10004.webp",
      "/images/queendom/group06/10082.webp",
      "/images/queendom/group06/10072.webp",
      "/images/queendom/group06/10013.webp",
      "/images/queendom/group07/10292.webp",
      "/images/queendom/group07/10315.webp",
      "/images/queendom/group07/10052.webp",
      "/images/queendom/group07/10113.webp",
      "/images/queendom/group06/10012.webp",
      "/images/queendom/group07/10034.webp",
      "/images/queendom/group06/10071.webp",
      "/images/queendom/group07/10486.webp",
      "/images/queendom/group07/10025.webp",
      "/images/queendom/group07/10121.webp",
      "/images/queendom/group07/10018.webp",
      "/images/queendom/group06/10065.webp",
      "/images/queendom/group06/10027.webp",
      "/images/queendom/group07/10084.webp",
      "/images/queendom/group06/10167.webp",
      "/images/queendom/group06/10014.webp",
      "/images/queendom/group07/10075.webp",
      "/images/queendom/group07/10031.webp",
      "/images/queendom/group07/10332.webp",
      "/images/queendom/group07/10042.webp",
      "/images/queendom/group07/20012.webp",
      "/images/queendom/group07/15914.webp",
      "/images/queendom/group06/10555.webp",
      "/images/queendom/group07/10097.webp",
      "/images/queendom/group06/10002.webp",
      "/images/queendom/group07/10314.webp",
      "/images/queendom/group07/12445.webp",
      "/images/queendom/group07/10030.webp",
      "/images/queendom/group07/10099.webp",
      "/images/queendom/group07/15787.webp",
      "/images/queendom/group06/10003.webp",
      "/images/queendom/group07/10333.webp",
      "/images/queendom/group06/10093.webp",
      "/images/queendom/group06/10000.webp",
      "/images/queendom/group06/10008.webp",
      "/images/queendom/group06/10043.webp",
      "/images/queendom/group07/12412.webp",
      "/images/queendom/group07/11818.webp",
      "/images/queendom/group06/10047.webp",
      "/images/queendom/group06/10005.webp",
      "/images/queendom/group07/10184.webp",
      "/images/queendom/group06/12487.webp",
      "/images/queendom/group06/10007.webp",
      "/images/queendom/group07/10182.webp",
      "/images/queendom/group07/10085.webp",
      "/images/queendom/group07/10032.webp",
      "/images/queendom/group07/12337.webp",
      "/images/queendom/group07/10047.webp",
      "/images/queendom/group07/10765.webp",
      "/images/queendom/group07/10455.webp",
      "/images/queendom/group06/10214.webp",
      "/images/queendom/group06/12486.webp",
      "/images/queendom/group07/10199.webp",
      "/images/queendom/group07/10129.webp",
      "/images/queendom/group06/10096.webp",
      "/images/queendom/group07/18620.webp",
      "/images/queendom/group07/10072.webp",
      "/images/queendom/group07/12576.webp",
      "/images/queendom/group07/10101.webp",
      "/images/queendom/group06/10455.webp"
    ],
    "isSpecial": true
  }
];
export const museSigCards = [
  {
    "id": 12,
    "amount": 1000,
    "frontImages": [
      "/images/muse/group01/1070.webp",
      "/images/muse/group01/1093.webp",
      "/images/muse/group01/1043.webp",
      "/images/muse/group01/1018.webp",
      "/images/muse/group01/1084.webp",
      "/images/muse/group01/1063.webp",
      "/images/muse/group01/1010.webp",
      "/images/muse/group01/1030.webp",
      "/images/muse/group01/1077.webp",
      "/images/muse/group01/1082.webp",
      "/images/muse/group01/1064.webp",
      "/images/muse/group01/1053.webp",
      "/images/muse/group01/1048.webp",
      "/images/muse/group01/1091.webp",
      "/images/muse/group01/1008.webp",
      "/images/muse/group01/1078.webp",
      "/images/muse/group01/1024.webp",
      "/images/muse/group01/1044.webp",
      "/images/muse/group01/1003.webp",
      "/images/muse/group01/1046.webp",
      "/images/muse/group01/1045.webp",
      "/images/muse/group01/1001.webp",
      "/images/muse/group01/1094.webp",
      "/images/muse/group01/1055.webp",
      "/images/muse/group01/1060.webp",
      "/images/muse/group01/1025.webp",
      "/images/muse/group01/1096.webp",
      "/images/muse/group01/1004.webp",
      "/images/muse/group01/1000.webp",
      "/images/muse/group01/1073.webp",
      "/images/muse/group01/1034.webp",
      "/images/muse/group01/1023.webp",
      "/images/muse/group01/1019.webp",
      "/images/muse/group01/1005.webp",
      "/images/muse/group01/1097.webp",
      "/images/muse/group01/1040.webp",
      "/images/muse/group01/1028.webp",
      "/images/muse/group01/1061.webp",
      "/images/muse/group01/1087.webp",
      "/images/muse/group01/1058.webp",
      "/images/muse/group01/1075.webp",
      "/images/muse/group01/1032.webp",
      "/images/muse/group01/1090.webp",
      "/images/muse/group01/1031.webp",
      "/images/muse/group01/1083.webp",
      "/images/muse/group01/1079.webp",
      "/images/muse/group01/1006.webp",
      "/images/muse/group01/1038.webp",
      "/images/muse/group01/1088.webp",
      "/images/muse/group01/1041.webp",
      "/images/muse/group01/1049.webp",
      "/images/muse/group01/1095.webp",
      "/images/muse/group01/1017.webp",
      "/images/muse/group01/1052.webp",
      "/images/muse/group01/1059.webp",
      "/images/muse/group01/1027.webp",
      "/images/muse/group01/1056.webp",
      "/images/muse/group01/1092.webp",
      "/images/muse/group01/1036.webp",
      "/images/muse/group01/1016.webp",
      "/images/muse/group01/1050.webp",
      "/images/muse/group01/1020.webp",
      "/images/muse/group01/1037.webp",
      "/images/muse/group01/1057.webp",
      "/images/muse/group01/1047.webp",
      "/images/muse/group01/1071.webp",
      "/images/muse/group01/1054.webp",
      "/images/muse/group01/1089.webp",
      "/images/muse/group01/1029.webp",
      "/images/muse/group01/1085.webp",
      "/images/muse/group01/1081.webp",
      "/images/muse/group01/1009.webp",
      "/images/muse/group01/1068.webp",
      "/images/muse/group01/1014.webp",
      "/images/muse/group01/1072.webp",
      "/images/muse/group01/1042.webp",
      "/images/muse/group01/1065.webp",
      "/images/muse/group01/1013.webp",
      "/images/muse/group01/1012.webp",
      "/images/muse/group01/1069.webp",
      "/images/muse/group01/1099.webp",
      "/images/muse/group01/1051.webp",
      "/images/muse/group01/1076.webp",
      "/images/muse/group01/1074.webp",
      "/images/muse/group01/1080.webp",
      "/images/muse/group01/1039.webp",
      "/images/muse/group01/1007.webp",
      "/images/muse/group01/1066.webp",
      "/images/muse/group01/1015.webp",
      "/images/muse/group01/1067.webp",
      "/images/muse/group01/1011.webp",
      "/images/muse/group01/1022.webp",
      "/images/muse/group01/1098.webp",
      "/images/muse/group01/1035.webp",
      "/images/muse/group01/1021.webp",
      "/images/muse/group01/1062.webp",
      "/images/muse/group01/1086.webp",
      "/images/muse/group01/1033.webp",
      "/images/muse/group01/1026.webp",
      "/images/muse/group01/1002.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 13,
    "amount": 2000,
    "frontImages": [
      "/images/muse/group02/1102.webp",
      "/images/muse/group03/1333.webp",
      "/images/muse/group02/1118.webp",
      "/images/muse/group05/5000.webp",
      "/images/muse/group02/1250.webp",
      "/images/muse/group03/1818.webp",
      "/images/muse/group02/1105.webp",
      "/images/muse/group02/1111.webp",
      "/images/muse/group01/1000.webp",
      "/images/muse/group01/1003.webp",
      "/images/muse/group02/1101.webp",
      "/images/muse/group02/1108.webp",
      "/images/muse/group02/1127.webp",
      "/images/muse/group03/1921.webp",
      "/images/muse/group02/1103.webp",
      "/images/muse/group02/1121.webp",
      "/images/muse/group03/1456.webp",
      "/images/muse/group03/1300.webp",
      "/images/muse/group03/1656.webp",
      "/images/muse/group04/2420.webp",
      "/images/muse/group01/1012.webp",
      "/images/muse/group02/1119.webp",
      "/images/muse/group02/1273.webp",
      "/images/muse/group01/1007.webp",
      "/images/muse/group03/1515.webp",
      "/images/muse/group01/1016.webp",
      "/images/muse/group03/1600.webp",
      "/images/muse/group04/2202.webp",
      "/images/muse/group04/3333.webp",
      "/images/muse/group03/1301.webp",
      "/images/muse/group04/2042.webp",
      "/images/muse/group04/3334.webp",
      "/images/muse/group04/2486.webp",
      "/images/muse/group02/1120.webp",
      "/images/muse/group02/1125.webp",
      "/images/muse/group04/2820.webp",
      "/images/muse/group01/1020.webp",
      "/images/muse/group01/1011.webp",
      "/images/muse/group04/2889.webp",
      "/images/muse/group02/1135.webp",
      "/images/muse/group04/3132.webp",
      "/images/muse/group01/1015.webp",
      "/images/muse/group04/2323.webp",
      "/images/muse/group01/1008.webp",
      "/images/muse/group01/1013.webp",
      "/images/muse/group03/1500.webp",
      "/images/muse/group01/1017.webp",
      "/images/muse/group01/1002.webp",
      "/images/muse/group04/3601.webp",
      "/images/muse/group02/1124.webp",
      "/images/muse/group02/1106.webp",
      "/images/muse/group02/1234.webp",
      "/images/muse/group02/1140.webp",
      "/images/muse/group04/3000.webp",
      "/images/muse/group01/1006.webp",
      "/images/muse/group04/2000.webp",
      "/images/muse/group05/8888.webp",
      "/images/muse/group04/2111.webp",
      "/images/muse/group04/2222.webp",
      "/images/muse/group03/1400.webp",
      "/images/muse/group02/1126.webp",
      "/images/muse/group01/1005.webp",
      "/images/muse/group01/1010.webp",
      "/images/muse/group04/3232.webp",
      "/images/muse/group04/3651.webp",
      "/images/muse/group04/3193.webp",
      "/images/muse/group02/1145.webp",
      "/images/muse/group04/3018.webp",
      "/images/muse/group05/6000.webp",
      "/images/muse/group01/1018.webp",
      "/images/muse/group02/1110.webp",
      "/images/muse/group01/1001.webp",
      "/images/muse/group05/5001.webp",
      "/images/muse/group02/1107.webp",
      "/images/muse/group03/1414.webp",
      "/images/muse/group01/1004.webp",
      "/images/muse/group03/1520.webp",
      "/images/muse/group04/2099.webp",
      "/images/muse/group02/1123.webp",
      "/images/muse/group02/1117.webp",
      "/images/muse/group01/1100.webp",
      "/images/muse/group04/2828.webp",
      "/images/muse/group02/1104.webp",
      "/images/muse/group02/1142.webp",
      "/images/muse/group05/7777.webp",
      "/images/muse/group04/2987.webp",
      "/images/muse/group02/1115.webp",
      "/images/muse/group02/1112.webp",
      "/images/muse/group02/1144.webp",
      "/images/muse/group01/1019.webp",
      "/images/muse/group05/7788.webp",
      "/images/muse/group04/3501.webp",
      "/images/muse/group01/1014.webp",
      "/images/muse/group02/1122.webp",
      "/images/muse/group04/2201.webp",
      "/images/muse/group04/2116.webp",
      "/images/muse/group01/1009.webp",
      "/images/muse/group02/1109.webp",
      "/images/muse/group02/1233.webp",
      "/images/muse/group02/1133.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 14,
    "amount": 3000,
    "frontImages": [
      "/images/muse/group01/1065.webp",
      "/images/muse/group02/1120.webp",
      "/images/muse/group01/1077.webp",
      "/images/muse/group01/1036.webp",
      "/images/muse/group01/1055.webp",
      "/images/muse/group01/1082.webp",
      "/images/muse/group01/1050.webp",
      "/images/muse/group01/1085.webp",
      "/images/muse/group02/1118.webp",
      "/images/muse/group01/1064.webp",
      "/images/muse/group01/1087.webp",
      "/images/muse/group01/1081.webp",
      "/images/muse/group01/1096.webp",
      "/images/muse/group01/1058.webp",
      "/images/muse/group02/1103.webp",
      "/images/muse/group01/1076.webp",
      "/images/muse/group01/1069.webp",
      "/images/muse/group01/1067.webp",
      "/images/muse/group02/1106.webp",
      "/images/muse/group01/1060.webp",
      "/images/muse/group01/1022.webp",
      "/images/muse/group01/1099.webp",
      "/images/muse/group01/1091.webp",
      "/images/muse/group01/1047.webp",
      "/images/muse/group02/1111.webp",
      "/images/muse/group02/1110.webp",
      "/images/muse/group01/1088.webp",
      "/images/muse/group01/1083.webp",
      "/images/muse/group01/1056.webp",
      "/images/muse/group01/1090.webp",
      "/images/muse/group01/1045.webp",
      "/images/muse/group01/1048.webp",
      "/images/muse/group01/1073.webp",
      "/images/muse/group01/1038.webp",
      "/images/muse/group02/1123.webp",
      "/images/muse/group02/1107.webp",
      "/images/muse/group01/1086.webp",
      "/images/muse/group01/1027.webp",
      "/images/muse/group01/1024.webp",
      "/images/muse/group01/1094.webp",
      "/images/muse/group02/1117.webp",
      "/images/muse/group01/1062.webp",
      "/images/muse/group02/1112.webp",
      "/images/muse/group01/1053.webp",
      "/images/muse/group01/1044.webp",
      "/images/muse/group01/1075.webp",
      "/images/muse/group01/1039.webp",
      "/images/muse/group01/1023.webp",
      "/images/muse/group01/1040.webp",
      "/images/muse/group01/1035.webp",
      "/images/muse/group01/1098.webp",
      "/images/muse/group02/1104.webp",
      "/images/muse/group01/1051.webp",
      "/images/muse/group01/1034.webp",
      "/images/muse/group01/1026.webp",
      "/images/muse/group01/1043.webp",
      "/images/muse/group01/1066.webp",
      "/images/muse/group01/1092.webp",
      "/images/muse/group01/1068.webp",
      "/images/muse/group01/1072.webp",
      "/images/muse/group01/1029.webp",
      "/images/muse/group02/1101.webp",
      "/images/muse/group01/1054.webp",
      "/images/muse/group01/1093.webp",
      "/images/muse/group01/1037.webp",
      "/images/muse/group01/1095.webp",
      "/images/muse/group01/1100.webp",
      "/images/muse/group01/1059.webp",
      "/images/muse/group01/1046.webp",
      "/images/muse/group01/1089.webp",
      "/images/muse/group01/1057.webp",
      "/images/muse/group02/1102.webp",
      "/images/muse/group01/1078.webp",
      "/images/muse/group02/1108.webp",
      "/images/muse/group02/1119.webp",
      "/images/muse/group01/1028.webp",
      "/images/muse/group02/1109.webp",
      "/images/muse/group01/1063.webp",
      "/images/muse/group01/1079.webp",
      "/images/muse/group02/1105.webp",
      "/images/muse/group01/1061.webp",
      "/images/muse/group01/1033.webp",
      "/images/muse/group02/1122.webp",
      "/images/muse/group01/1084.webp",
      "/images/muse/group01/1031.webp",
      "/images/muse/group01/1030.webp",
      "/images/muse/group01/1070.webp",
      "/images/muse/group02/1121.webp",
      "/images/muse/group01/1097.webp",
      "/images/muse/group01/1074.webp",
      "/images/muse/group01/1080.webp",
      "/images/muse/group01/1042.webp",
      "/images/muse/group01/1041.webp",
      "/images/muse/group01/1021.webp",
      "/images/muse/group01/1071.webp",
      "/images/muse/group01/1049.webp",
      "/images/muse/group01/1025.webp",
      "/images/muse/group01/1032.webp",
      "/images/muse/group01/1052.webp",
      "/images/muse/group02/1115.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 15,
    "amount": 4000,
    "frontImages": [
      "/images/muse/group05/5000.webp",
      "/images/muse/group01/1021.webp",
      "/images/muse/group01/1008.webp",
      "/images/muse/group02/1133.webp",
      "/images/muse/group03/1515.webp",
      "/images/muse/group01/1028.webp",
      "/images/muse/group03/1400.webp",
      "/images/muse/group02/1144.webp",
      "/images/muse/group01/1022.webp",
      "/images/muse/group05/8888.webp",
      "/images/muse/group01/1018.webp",
      "/images/muse/group04/3132.webp",
      "/images/muse/group05/5001.webp",
      "/images/muse/group02/1140.webp",
      "/images/muse/group01/1031.webp",
      "/images/muse/group04/3501.webp",
      "/images/muse/group04/3333.webp",
      "/images/muse/group02/1127.webp",
      "/images/muse/group01/1032.webp",
      "/images/muse/group01/1015.webp",
      "/images/muse/group02/1135.webp",
      "/images/muse/group04/3000.webp",
      "/images/muse/group03/1414.webp",
      "/images/muse/group01/1006.webp",
      "/images/muse/group02/1234.webp",
      "/images/muse/group04/3601.webp",
      "/images/muse/group01/1010.webp",
      "/images/muse/group04/2099.webp",
      "/images/muse/group03/1333.webp",
      "/images/muse/group03/1656.webp",
      "/images/muse/group02/1273.webp",
      "/images/muse/group05/7777.webp",
      "/images/muse/group04/2323.webp",
      "/images/muse/group04/3018.webp",
      "/images/muse/group01/1033.webp",
      "/images/muse/group01/1026.webp",
      "/images/muse/group04/3193.webp",
      "/images/muse/group02/1233.webp",
      "/images/muse/group01/1013.webp",
      "/images/muse/group01/1036.webp",
      "/images/muse/group01/1040.webp",
      "/images/muse/group01/1038.webp",
      "/images/muse/group04/3334.webp",
      "/images/muse/group04/2420.webp",
      "/images/muse/group01/1011.webp",
      "/images/muse/group04/3651.webp",
      "/images/muse/group01/1000.webp",
      "/images/muse/group02/1250.webp",
      "/images/muse/group01/1005.webp",
      "/images/muse/group01/1020.webp",
      "/images/muse/group01/1034.webp",
      "/images/muse/group04/2202.webp",
      "/images/muse/group03/1520.webp",
      "/images/muse/group02/1124.webp",
      "/images/muse/group01/1014.webp",
      "/images/muse/group05/6000.webp",
      "/images/muse/group01/1002.webp",
      "/images/muse/group04/3232.webp",
      "/images/muse/group04/2222.webp",
      "/images/muse/group02/1142.webp",
      "/images/muse/group04/2987.webp",
      "/images/muse/group02/1125.webp",
      "/images/muse/group01/1007.webp",
      "/images/muse/group03/1600.webp",
      "/images/muse/group03/1300.webp",
      "/images/muse/group03/1456.webp",
      "/images/muse/group04/2828.webp",
      "/images/muse/group04/2889.webp",
      "/images/muse/group03/1921.webp",
      "/images/muse/group04/2111.webp",
      "/images/muse/group01/1023.webp",
      "/images/muse/group01/1030.webp",
      "/images/muse/group04/2486.webp",
      "/images/muse/group02/1145.webp",
      "/images/muse/group05/7788.webp",
      "/images/muse/group01/1012.webp",
      "/images/muse/group04/2000.webp",
      "/images/muse/group01/1016.webp",
      "/images/muse/group04/2820.webp",
      "/images/muse/group01/1041.webp",
      "/images/muse/group01/1024.webp",
      "/images/muse/group04/2201.webp",
      "/images/muse/group01/1019.webp",
      "/images/muse/group02/1126.webp",
      "/images/muse/group03/1301.webp",
      "/images/muse/group01/1025.webp",
      "/images/muse/group01/1017.webp",
      "/images/muse/group01/1039.webp",
      "/images/muse/group01/1029.webp",
      "/images/muse/group03/1500.webp",
      "/images/muse/group01/1027.webp",
      "/images/muse/group01/1037.webp",
      "/images/muse/group01/1009.webp",
      "/images/muse/group01/1004.webp",
      "/images/muse/group01/1035.webp",
      "/images/muse/group01/1003.webp",
      "/images/muse/group01/1001.webp",
      "/images/muse/group04/2042.webp",
      "/images/muse/group04/2116.webp",
      "/images/muse/group03/1818.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 16,
    "amount": 5000,
    "frontImages": [
      "/images/muse/group01/1062.webp",
      "/images/muse/group01/1085.webp",
      "/images/muse/group01/1050.webp",
      "/images/muse/group01/1084.webp",
      "/images/muse/group03/1414.webp",
      "/images/muse/group01/1072.webp",
      "/images/muse/group03/1456.webp",
      "/images/muse/group01/1057.webp",
      "/images/muse/group01/1091.webp",
      "/images/muse/group02/1125.webp",
      "/images/muse/group03/1500.webp",
      "/images/muse/group01/1080.webp",
      "/images/muse/group01/1067.webp",
      "/images/muse/group02/1144.webp",
      "/images/muse/group01/1071.webp",
      "/images/muse/group01/1053.webp",
      "/images/muse/group02/1101.webp",
      "/images/muse/group01/1043.webp",
      "/images/muse/group02/1250.webp",
      "/images/muse/group03/1300.webp",
      "/images/muse/group01/1049.webp",
      "/images/muse/group02/1106.webp",
      "/images/muse/group02/1127.webp",
      "/images/muse/group02/1142.webp",
      "/images/muse/group02/1107.webp",
      "/images/muse/group02/1112.webp",
      "/images/muse/group01/1052.webp",
      "/images/muse/group01/1061.webp",
      "/images/muse/group02/1135.webp",
      "/images/muse/group01/1079.webp",
      "/images/muse/group01/1095.webp",
      "/images/muse/group02/1108.webp",
      "/images/muse/group02/1233.webp",
      "/images/muse/group03/1333.webp",
      "/images/muse/group01/1063.webp",
      "/images/muse/group01/1078.webp",
      "/images/muse/group01/1089.webp",
      "/images/muse/group01/1064.webp",
      "/images/muse/group02/1104.webp",
      "/images/muse/group01/1054.webp",
      "/images/muse/group01/1068.webp",
      "/images/muse/group01/1051.webp",
      "/images/muse/group01/1075.webp",
      "/images/muse/group02/1234.webp",
      "/images/muse/group02/1120.webp",
      "/images/muse/group01/1042.webp",
      "/images/muse/group01/1098.webp",
      "/images/muse/group01/1056.webp",
      "/images/muse/group01/1077.webp",
      "/images/muse/group02/1122.webp",
      "/images/muse/group01/1070.webp",
      "/images/muse/group01/1100.webp",
      "/images/muse/group01/1048.webp",
      "/images/muse/group01/1065.webp",
      "/images/muse/group01/1058.webp",
      "/images/muse/group01/1046.webp",
      "/images/muse/group02/1110.webp",
      "/images/muse/group01/1087.webp",
      "/images/muse/group01/1092.webp",
      "/images/muse/group02/1126.webp",
      "/images/muse/group01/1097.webp",
      "/images/muse/group01/1094.webp",
      "/images/muse/group01/1081.webp",
      "/images/muse/group01/1088.webp",
      "/images/muse/group01/1044.webp",
      "/images/muse/group01/1055.webp",
      "/images/muse/group02/1273.webp",
      "/images/muse/group02/1123.webp",
      "/images/muse/group01/1096.webp",
      "/images/muse/group02/1115.webp",
      "/images/muse/group01/1093.webp",
      "/images/muse/group02/1111.webp",
      "/images/muse/group02/1103.webp",
      "/images/muse/group01/1086.webp",
      "/images/muse/group02/1105.webp",
      "/images/muse/group01/1045.webp",
      "/images/muse/group01/1059.webp",
      "/images/muse/group02/1117.webp",
      "/images/muse/group02/1140.webp",
      "/images/muse/group01/1069.webp",
      "/images/muse/group01/1060.webp",
      "/images/muse/group02/1145.webp",
      "/images/muse/group01/1066.webp",
      "/images/muse/group02/1121.webp",
      "/images/muse/group03/1301.webp",
      "/images/muse/group02/1102.webp",
      "/images/muse/group01/1076.webp",
      "/images/muse/group01/1073.webp",
      "/images/muse/group02/1133.webp",
      "/images/muse/group01/1047.webp",
      "/images/muse/group01/1074.webp",
      "/images/muse/group03/1400.webp",
      "/images/muse/group01/1083.webp",
      "/images/muse/group02/1118.webp",
      "/images/muse/group02/1124.webp",
      "/images/muse/group02/1119.webp",
      "/images/muse/group01/1082.webp",
      "/images/muse/group01/1099.webp",
      "/images/muse/group02/1109.webp",
      "/images/muse/group01/1090.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 17,
    "amount": 6000,
    "frontImages": [
      "/images/muse/group01/1060.webp",
      "/images/muse/group04/2111.webp",
      "/images/muse/group01/1018.webp",
      "/images/muse/group01/1022.webp",
      "/images/muse/group01/1047.webp",
      "/images/muse/group01/1009.webp",
      "/images/muse/group01/1024.webp",
      "/images/muse/group01/1023.webp",
      "/images/muse/group05/5001.webp",
      "/images/muse/group01/1020.webp",
      "/images/muse/group01/1050.webp",
      "/images/muse/group04/3601.webp",
      "/images/muse/group04/2202.webp",
      "/images/muse/group04/2987.webp",
      "/images/muse/group01/1052.webp",
      "/images/muse/group01/1040.webp",
      "/images/muse/group01/1003.webp",
      "/images/muse/group04/2820.webp",
      "/images/muse/group01/1054.webp",
      "/images/muse/group01/1013.webp",
      "/images/muse/group04/2828.webp",
      "/images/muse/group01/1046.webp",
      "/images/muse/group01/1053.webp",
      "/images/muse/group04/3232.webp",
      "/images/muse/group03/1600.webp",
      "/images/muse/group01/1004.webp",
      "/images/muse/group05/7777.webp",
      "/images/muse/group05/5000.webp",
      "/images/muse/group03/1818.webp",
      "/images/muse/group04/3132.webp",
      "/images/muse/group01/1058.webp",
      "/images/muse/group01/1010.webp",
      "/images/muse/group01/1033.webp",
      "/images/muse/group01/1042.webp",
      "/images/muse/group05/7788.webp",
      "/images/muse/group01/1006.webp",
      "/images/muse/group04/3334.webp",
      "/images/muse/group04/2116.webp",
      "/images/muse/group01/1017.webp",
      "/images/muse/group04/3651.webp",
      "/images/muse/group01/1037.webp",
      "/images/muse/group01/1025.webp",
      "/images/muse/group04/2201.webp",
      "/images/muse/group04/2042.webp",
      "/images/muse/group04/3000.webp",
      "/images/muse/group01/1061.webp",
      "/images/muse/group01/1014.webp",
      "/images/muse/group01/1059.webp",
      "/images/muse/group01/1016.webp",
      "/images/muse/group01/1049.webp",
      "/images/muse/group04/2420.webp",
      "/images/muse/group04/3333.webp",
      "/images/muse/group04/2323.webp",
      "/images/muse/group01/1051.webp",
      "/images/muse/group04/3018.webp",
      "/images/muse/group01/1036.webp",
      "/images/muse/group01/1034.webp",
      "/images/muse/group04/3193.webp",
      "/images/muse/group01/1026.webp",
      "/images/muse/group01/1027.webp",
      "/images/muse/group05/6000.webp",
      "/images/muse/group01/1015.webp",
      "/images/muse/group01/1035.webp",
      "/images/muse/group01/1062.webp",
      "/images/muse/group04/2000.webp",
      "/images/muse/group01/1012.webp",
      "/images/muse/group01/1039.webp",
      "/images/muse/group04/3501.webp",
      "/images/muse/group01/1002.webp",
      "/images/muse/group01/1056.webp",
      "/images/muse/group01/1048.webp",
      "/images/muse/group01/1055.webp",
      "/images/muse/group01/1008.webp",
      "/images/muse/group01/1019.webp",
      "/images/muse/group04/2889.webp",
      "/images/muse/group01/1011.webp",
      "/images/muse/group03/1921.webp",
      "/images/muse/group01/1030.webp",
      "/images/muse/group05/8888.webp",
      "/images/muse/group01/1007.webp",
      "/images/muse/group04/2099.webp",
      "/images/muse/group03/1515.webp",
      "/images/muse/group01/1001.webp",
      "/images/muse/group01/1028.webp",
      "/images/muse/group01/1000.webp",
      "/images/muse/group01/1041.webp",
      "/images/muse/group04/2222.webp",
      "/images/muse/group01/1044.webp",
      "/images/muse/group01/1029.webp",
      "/images/muse/group01/1005.webp",
      "/images/muse/group01/1031.webp",
      "/images/muse/group01/1057.webp",
      "/images/muse/group03/1520.webp",
      "/images/muse/group04/2486.webp",
      "/images/muse/group01/1043.webp",
      "/images/muse/group01/1021.webp",
      "/images/muse/group01/1032.webp",
      "/images/muse/group01/1045.webp",
      "/images/muse/group03/1656.webp",
      "/images/muse/group01/1038.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 18,
    "amount": 7000,
    "frontImages": [
      "/images/muse/group04/2111.webp",
      "/images/muse/group01/1073.webp",
      "/images/muse/group02/1122.webp",
      "/images/muse/group03/1400.webp",
      "/images/muse/group01/1088.webp",
      "/images/muse/group04/2486.webp",
      "/images/muse/group03/1456.webp",
      "/images/muse/group01/1080.webp",
      "/images/muse/group02/1273.webp",
      "/images/muse/group02/1111.webp",
      "/images/muse/group02/1120.webp",
      "/images/muse/group01/1070.webp",
      "/images/muse/group04/2889.webp",
      "/images/muse/group01/1077.webp",
      "/images/muse/group01/1064.webp",
      "/images/muse/group02/1108.webp",
      "/images/muse/group01/1091.webp",
      "/images/muse/group01/1069.webp",
      "/images/muse/group02/1126.webp",
      "/images/muse/group02/1105.webp",
      "/images/muse/group01/1084.webp",
      "/images/muse/group01/1071.webp",
      "/images/muse/group02/1119.webp",
      "/images/muse/group01/1100.webp",
      "/images/muse/group02/1123.webp",
      "/images/muse/group02/1127.webp",
      "/images/muse/group01/1097.webp",
      "/images/muse/group04/2202.webp",
      "/images/muse/group01/1083.webp",
      "/images/muse/group02/1121.webp",
      "/images/muse/group01/1090.webp",
      "/images/muse/group04/2042.webp",
      "/images/muse/group02/1118.webp",
      "/images/muse/group01/1099.webp",
      "/images/muse/group02/1103.webp",
      "/images/muse/group02/1124.webp",
      "/images/muse/group03/1500.webp",
      "/images/muse/group03/1520.webp",
      "/images/muse/group02/1109.webp",
      "/images/muse/group01/1098.webp",
      "/images/muse/group01/1086.webp",
      "/images/muse/group04/2323.webp",
      "/images/muse/group04/2116.webp",
      "/images/muse/group02/1125.webp",
      "/images/muse/group01/1068.webp",
      "/images/muse/group02/1145.webp",
      "/images/muse/group01/1075.webp",
      "/images/muse/group04/2201.webp",
      "/images/muse/group01/1066.webp",
      "/images/muse/group03/1921.webp",
      "/images/muse/group01/1093.webp",
      "/images/muse/group03/1600.webp",
      "/images/muse/group02/1107.webp",
      "/images/muse/group01/1065.webp",
      "/images/muse/group04/2099.webp",
      "/images/muse/group04/2222.webp",
      "/images/muse/group01/1087.webp",
      "/images/muse/group04/2987.webp",
      "/images/muse/group02/1135.webp",
      "/images/muse/group01/1079.webp",
      "/images/muse/group02/1102.webp",
      "/images/muse/group01/1063.webp",
      "/images/muse/group01/1081.webp",
      "/images/muse/group01/1072.webp",
      "/images/muse/group04/2820.webp",
      "/images/muse/group02/1115.webp",
      "/images/muse/group02/1133.webp",
      "/images/muse/group04/2000.webp",
      "/images/muse/group04/2420.webp",
      "/images/muse/group01/1089.webp",
      "/images/muse/group02/1106.webp",
      "/images/muse/group01/1074.webp",
      "/images/muse/group02/1142.webp",
      "/images/muse/group01/1078.webp",
      "/images/muse/group01/1095.webp",
      "/images/muse/group02/1250.webp",
      "/images/muse/group03/1301.webp",
      "/images/muse/group04/2828.webp",
      "/images/muse/group03/1414.webp",
      "/images/muse/group02/1140.webp",
      "/images/muse/group02/1234.webp",
      "/images/muse/group01/1082.webp",
      "/images/muse/group02/1112.webp",
      "/images/muse/group01/1094.webp",
      "/images/muse/group02/1104.webp",
      "/images/muse/group01/1096.webp",
      "/images/muse/group02/1110.webp",
      "/images/muse/group01/1092.webp",
      "/images/muse/group03/1818.webp",
      "/images/muse/group03/1300.webp",
      "/images/muse/group02/1117.webp",
      "/images/muse/group03/1656.webp",
      "/images/muse/group01/1067.webp",
      "/images/muse/group02/1144.webp",
      "/images/muse/group01/1076.webp",
      "/images/muse/group02/1101.webp",
      "/images/muse/group03/1333.webp",
      "/images/muse/group01/1085.webp",
      "/images/muse/group03/1515.webp",
      "/images/muse/group02/1233.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 19,
    "amount": 8000,
    "frontImages": [
      "/images/muse/group01/1047.webp",
      "/images/muse/group01/1002.webp",
      "/images/muse/group01/1046.webp",
      "/images/muse/group01/1063.webp",
      "/images/muse/group01/1011.webp",
      "/images/muse/group01/1058.webp",
      "/images/muse/group01/1024.webp",
      "/images/muse/group01/1037.webp",
      "/images/muse/group01/1078.webp",
      "/images/muse/group01/1016.webp",
      "/images/muse/group01/1039.webp",
      "/images/muse/group01/1069.webp",
      "/images/muse/group05/5001.webp",
      "/images/muse/group01/1075.webp",
      "/images/muse/group01/1035.webp",
      "/images/muse/group01/1065.webp",
      "/images/muse/group01/1060.webp",
      "/images/muse/group01/1042.webp",
      "/images/muse/group04/3334.webp",
      "/images/muse/group01/1055.webp",
      "/images/muse/group01/1053.webp",
      "/images/muse/group01/1025.webp",
      "/images/muse/group01/1041.webp",
      "/images/muse/group01/1009.webp",
      "/images/muse/group01/1006.webp",
      "/images/muse/group05/7788.webp",
      "/images/muse/group01/1027.webp",
      "/images/muse/group01/1020.webp",
      "/images/muse/group01/1071.webp",
      "/images/muse/group01/1022.webp",
      "/images/muse/group01/1082.webp",
      "/images/muse/group01/1029.webp",
      "/images/muse/group01/1000.webp",
      "/images/muse/group01/1062.webp",
      "/images/muse/group01/1079.webp",
      "/images/muse/group01/1040.webp",
      "/images/muse/group01/1034.webp",
      "/images/muse/group04/3193.webp",
      "/images/muse/group01/1021.webp",
      "/images/muse/group01/1010.webp",
      "/images/muse/group01/1050.webp",
      "/images/muse/group01/1080.webp",
      "/images/muse/group01/1064.webp",
      "/images/muse/group01/1077.webp",
      "/images/muse/group01/1036.webp",
      "/images/muse/group01/1012.webp",
      "/images/muse/group01/1019.webp",
      "/images/muse/group01/1015.webp",
      "/images/muse/group01/1045.webp",
      "/images/muse/group01/1033.webp",
      "/images/muse/group01/1057.webp",
      "/images/muse/group01/1044.webp",
      "/images/muse/group01/1013.webp",
      "/images/muse/group01/1048.webp",
      "/images/muse/group01/1068.webp",
      "/images/muse/group01/1007.webp",
      "/images/muse/group05/8888.webp",
      "/images/muse/group01/1074.webp",
      "/images/muse/group04/3000.webp",
      "/images/muse/group01/1052.webp",
      "/images/muse/group01/1070.webp",
      "/images/muse/group01/1030.webp",
      "/images/muse/group01/1083.webp",
      "/images/muse/group01/1032.webp",
      "/images/muse/group01/1018.webp",
      "/images/muse/group04/3018.webp",
      "/images/muse/group01/1059.webp",
      "/images/muse/group01/1031.webp",
      "/images/muse/group01/1003.webp",
      "/images/muse/group01/1023.webp",
      "/images/muse/group04/3333.webp",
      "/images/muse/group01/1004.webp",
      "/images/muse/group01/1072.webp",
      "/images/muse/group01/1017.webp",
      "/images/muse/group01/1008.webp",
      "/images/muse/group01/1049.webp",
      "/images/muse/group04/3651.webp",
      "/images/muse/group01/1005.webp",
      "/images/muse/group01/1081.webp",
      "/images/muse/group05/6000.webp",
      "/images/muse/group01/1061.webp",
      "/images/muse/group04/3501.webp",
      "/images/muse/group04/3132.webp",
      "/images/muse/group01/1066.webp",
      "/images/muse/group05/7777.webp",
      "/images/muse/group01/1038.webp",
      "/images/muse/group01/1001.webp",
      "/images/muse/group01/1026.webp",
      "/images/muse/group01/1067.webp",
      "/images/muse/group01/1028.webp",
      "/images/muse/group01/1043.webp",
      "/images/muse/group01/1056.webp",
      "/images/muse/group01/1076.webp",
      "/images/muse/group05/5000.webp",
      "/images/muse/group01/1051.webp",
      "/images/muse/group04/3232.webp",
      "/images/muse/group01/1054.webp",
      "/images/muse/group01/1014.webp",
      "/images/muse/group04/3601.webp",
      "/images/muse/group01/1073.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 20,
    "amount": 9000,
    "frontImages": [
      "/images/muse/group02/1107.webp",
      "/images/muse/group01/1093.webp",
      "/images/muse/group04/3193.webp",
      "/images/muse/group04/2420.webp",
      "/images/muse/group04/2111.webp",
      "/images/muse/group04/3334.webp",
      "/images/muse/group04/2323.webp",
      "/images/muse/group03/1333.webp",
      "/images/muse/group02/1144.webp",
      "/images/muse/group02/1127.webp",
      "/images/muse/group02/1110.webp",
      "/images/muse/group04/2828.webp",
      "/images/muse/group02/1234.webp",
      "/images/muse/group04/2889.webp",
      "/images/muse/group01/1096.webp",
      "/images/muse/group02/1233.webp",
      "/images/muse/group01/1089.webp",
      "/images/muse/group01/1000.webp",
      "/images/muse/group02/1122.webp",
      "/images/muse/group05/6000.webp",
      "/images/muse/group01/1090.webp",
      "/images/muse/group01/1002.webp",
      "/images/muse/group05/7788.webp",
      "/images/muse/group04/3232.webp",
      "/images/muse/group02/1140.webp",
      "/images/muse/group02/1121.webp",
      "/images/muse/group02/1145.webp",
      "/images/muse/group02/1273.webp",
      "/images/muse/group04/2201.webp",
      "/images/muse/group04/3132.webp",
      "/images/muse/group01/1091.webp",
      "/images/muse/group03/1500.webp",
      "/images/muse/group01/1100.webp",
      "/images/muse/group04/3651.webp",
      "/images/muse/group03/1414.webp",
      "/images/muse/group02/1106.webp",
      "/images/muse/group02/1124.webp",
      "/images/muse/group04/2222.webp",
      "/images/muse/group05/8888.webp",
      "/images/muse/group05/5000.webp",
      "/images/muse/group04/2116.webp",
      "/images/muse/group01/1097.webp",
      "/images/muse/group02/1103.webp",
      "/images/muse/group03/1301.webp",
      "/images/muse/group04/3333.webp",
      "/images/muse/group03/1515.webp",
      "/images/muse/group04/3018.webp",
      "/images/muse/group05/5001.webp",
      "/images/muse/group03/1818.webp",
      "/images/muse/group03/1456.webp",
      "/images/muse/group02/1115.webp",
      "/images/muse/group01/1095.webp",
      "/images/muse/group02/1120.webp",
      "/images/muse/group04/2987.webp",
      "/images/muse/group03/1300.webp",
      "/images/muse/group01/1086.webp",
      "/images/muse/group02/1112.webp",
      "/images/muse/group02/1119.webp",
      "/images/muse/group01/1088.webp",
      "/images/muse/group04/2820.webp",
      "/images/muse/group04/2202.webp",
      "/images/muse/group01/1092.webp",
      "/images/muse/group02/1101.webp",
      "/images/muse/group04/2486.webp",
      "/images/muse/group02/1108.webp",
      "/images/muse/group02/1111.webp",
      "/images/muse/group02/1142.webp",
      "/images/muse/group04/2099.webp",
      "/images/muse/group05/7777.webp",
      "/images/muse/group04/3501.webp",
      "/images/muse/group02/1250.webp",
      "/images/muse/group02/1105.webp",
      "/images/muse/group04/3000.webp",
      "/images/muse/group02/1133.webp",
      "/images/muse/group01/1085.webp",
      "/images/muse/group02/1109.webp",
      "/images/muse/group01/1087.webp",
      "/images/muse/group01/1098.webp",
      "/images/muse/group01/1001.webp",
      "/images/muse/group02/1125.webp",
      "/images/muse/group03/1400.webp",
      "/images/muse/group03/1520.webp",
      "/images/muse/group03/1600.webp",
      "/images/muse/group02/1135.webp",
      "/images/muse/group01/1099.webp",
      "/images/muse/group02/1126.webp",
      "/images/muse/group03/1656.webp",
      "/images/muse/group04/2042.webp",
      "/images/muse/group02/1117.webp",
      "/images/muse/group03/1921.webp",
      "/images/muse/group01/1004.webp",
      "/images/muse/group04/3601.webp",
      "/images/muse/group02/1104.webp",
      "/images/muse/group02/1123.webp",
      "/images/muse/group02/1118.webp",
      "/images/muse/group01/1094.webp",
      "/images/muse/group01/1003.webp",
      "/images/muse/group02/1102.webp",
      "/images/muse/group04/2000.webp",
      "/images/muse/group01/1084.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 21,
    "amount": 10000,
    "frontImages": [
      "/images/muse/group01/1074.webp",
      "/images/muse/group01/1026.webp",
      "/images/muse/group01/1006.webp",
      "/images/muse/group01/1083.webp",
      "/images/muse/group01/1044.webp",
      "/images/muse/group01/1097.webp",
      "/images/muse/group01/1061.webp",
      "/images/muse/group01/1092.webp",
      "/images/muse/group01/1086.webp",
      "/images/muse/group01/1038.webp",
      "/images/muse/group02/1104.webp",
      "/images/muse/group01/1017.webp",
      "/images/muse/group01/1075.webp",
      "/images/muse/group01/1100.webp",
      "/images/muse/group01/1050.webp",
      "/images/muse/group01/1012.webp",
      "/images/muse/group02/1102.webp",
      "/images/muse/group01/1035.webp",
      "/images/muse/group01/1042.webp",
      "/images/muse/group01/1009.webp",
      "/images/muse/group01/1051.webp",
      "/images/muse/group01/1041.webp",
      "/images/muse/group01/1007.webp",
      "/images/muse/group01/1033.webp",
      "/images/muse/group01/1018.webp",
      "/images/muse/group01/1063.webp",
      "/images/muse/group01/1073.webp",
      "/images/muse/group01/1099.webp",
      "/images/muse/group01/1023.webp",
      "/images/muse/group01/1077.webp",
      "/images/muse/group01/1049.webp",
      "/images/muse/group01/1014.webp",
      "/images/muse/group01/1031.webp",
      "/images/muse/group01/1024.webp",
      "/images/muse/group01/1081.webp",
      "/images/muse/group01/1069.webp",
      "/images/muse/group01/1022.webp",
      "/images/muse/group01/1079.webp",
      "/images/muse/group01/1019.webp",
      "/images/muse/group01/1037.webp",
      "/images/muse/group01/1013.webp",
      "/images/muse/group01/1029.webp",
      "/images/muse/group01/1094.webp",
      "/images/muse/group01/1016.webp",
      "/images/muse/group01/1095.webp",
      "/images/muse/group01/1096.webp",
      "/images/muse/group01/1027.webp",
      "/images/muse/group01/1070.webp",
      "/images/muse/group01/1088.webp",
      "/images/muse/group01/1053.webp",
      "/images/muse/group01/1089.webp",
      "/images/muse/group01/1030.webp",
      "/images/muse/group01/1078.webp",
      "/images/muse/group01/1062.webp",
      "/images/muse/group01/1020.webp",
      "/images/muse/group01/1052.webp",
      "/images/muse/group01/1008.webp",
      "/images/muse/group01/1059.webp",
      "/images/muse/group01/1046.webp",
      "/images/muse/group01/1005.webp",
      "/images/muse/group01/1043.webp",
      "/images/muse/group01/1071.webp",
      "/images/muse/group01/1065.webp",
      "/images/muse/group01/1055.webp",
      "/images/muse/group01/1067.webp",
      "/images/muse/group01/1084.webp",
      "/images/muse/group01/1090.webp",
      "/images/muse/group01/1028.webp",
      "/images/muse/group01/1032.webp",
      "/images/muse/group01/1048.webp",
      "/images/muse/group02/1101.webp",
      "/images/muse/group01/1056.webp",
      "/images/muse/group01/1021.webp",
      "/images/muse/group01/1066.webp",
      "/images/muse/group01/1011.webp",
      "/images/muse/group01/1072.webp",
      "/images/muse/group01/1057.webp",
      "/images/muse/group01/1098.webp",
      "/images/muse/group01/1087.webp",
      "/images/muse/group01/1064.webp",
      "/images/muse/group01/1040.webp",
      "/images/muse/group01/1025.webp",
      "/images/muse/group02/1103.webp",
      "/images/muse/group01/1093.webp",
      "/images/muse/group01/1068.webp",
      "/images/muse/group01/1036.webp",
      "/images/muse/group01/1039.webp",
      "/images/muse/group01/1034.webp",
      "/images/muse/group01/1015.webp",
      "/images/muse/group01/1058.webp",
      "/images/muse/group01/1047.webp",
      "/images/muse/group01/1091.webp",
      "/images/muse/group01/1085.webp",
      "/images/muse/group01/1010.webp",
      "/images/muse/group01/1060.webp",
      "/images/muse/group01/1082.webp",
      "/images/muse/group01/1054.webp",
      "/images/muse/group01/1076.webp",
      "/images/muse/group01/1045.webp",
      "/images/muse/group01/1080.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 22,
    "amount": 50000,
    "frontImages": [
      "/images/muse/group06/10072.webp",
      "/images/muse/group06/10077.webp",
      "/images/muse/group06/10133.webp",
      "/images/muse/group06/10057.webp",
      "/images/muse/group06/10272.webp",
      "/images/muse/group06/10135.webp",
      "/images/muse/group06/10187.webp",
      "/images/muse/group06/10164.webp",
      "/images/muse/group06/10042.webp",
      "/images/muse/group06/10089.webp",
      "/images/muse/group06/10111.webp",
      "/images/muse/group06/10152.webp",
      "/images/muse/group06/10043.webp",
      "/images/muse/group06/10083.webp",
      "/images/muse/group06/10142.webp",
      "/images/muse/group06/10078.webp",
      "/images/muse/group06/10145.webp",
      "/images/muse/group06/10000.webp",
      "/images/muse/group06/10084.webp",
      "/images/muse/group06/10188.webp"
    ],
    "isSpecial": true
  }
];
export const holicSigCards = [
  {
    "id": 23,
    "amount": 1000,
    "frontImages": [
      "/images/holic/group02/1103.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group01/1052.webp",
      "/images/holic/group01/1059.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group03/1515.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group02/1113.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group02/1109.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group02/1101.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group01/1026.webp",
      "/images/holic/group01/1074.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 24,
    "amount": 2000,
    "frontImages": [
      "/images/holic/group01/1052.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group01/1026.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group01/1074.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group04/3200.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group01/1059.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 25,
    "amount": 3000,
    "frontImages": [
      "/images/holic/group01/1041.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group02/1113.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group03/1515.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group02/1101.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group04/3200.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group02/1103.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group01/1026.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group02/1109.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group01/1052.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group01/1059.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group01/1014.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 26,
    "amount": 4000,
    "frontImages": [
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group03/1515.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group02/1113.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group02/1103.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group04/3200.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1026.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group02/1101.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group02/1109.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1074.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 27,
    "amount": 5000,
    "frontImages": [
      "/images/holic/group01/1021.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group02/1109.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group01/1059.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group02/1101.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1074.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group01/1052.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group02/1103.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group03/1515.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group04/3200.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group02/1113.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group01/1018.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 28,
    "amount": 6000,
    "frontImages": [
      "/images/holic/group02/1113.webp",
      "/images/holic/group02/1103.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group01/1052.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group01/1026.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group02/1109.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group01/1059.webp",
      "/images/holic/group01/1074.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group02/1101.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group03/1515.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group04/3200.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 29,
    "amount": 7000,
    "frontImages": [
      "/images/holic/group03/1515.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1074.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group02/1101.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group02/1109.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group01/1052.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group01/1059.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group02/1113.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group02/1103.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group01/1026.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 30,
    "amount": 8000,
    "frontImages": [
      "/images/holic/group02/1101.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group01/1074.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group01/1052.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group04/3200.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group02/1103.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1059.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group01/1026.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 31,
    "amount": 9000,
    "frontImages": [
      "/images/holic/group01/1025.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group02/1109.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group01/1050.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group01/1040.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group01/1056.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group02/1113.webp",
      "/images/holic/group04/3200.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group01/1061.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1064.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group01/1068.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group01/1053.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group01/1063.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group01/1026.webp",
      "/images/holic/group01/1054.webp",
      "/images/holic/group01/1066.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group01/1067.webp",
      "/images/holic/group01/1052.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group01/1057.webp",
      "/images/holic/group01/1062.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group01/1055.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group01/1060.webp",
      "/images/holic/group01/1051.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group01/1065.webp",
      "/images/holic/group01/1059.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1058.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group03/1515.webp",
      "/images/holic/group01/1001.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 32,
    "amount": 10000,
    "frontImages": [
      "/images/holic/group01/1040.webp",
      "/images/holic/group03/1515.webp",
      "/images/holic/group01/1001.webp",
      "/images/holic/group04/2001.webp",
      "/images/holic/group01/1012.webp",
      "/images/holic/group02/1110.webp",
      "/images/holic/group01/1032.webp",
      "/images/holic/group01/1049.webp",
      "/images/holic/group01/1072.webp",
      "/images/holic/group03/1520.webp",
      "/images/holic/group01/1007.webp",
      "/images/holic/group01/1087.webp",
      "/images/holic/group01/1073.webp",
      "/images/holic/group05/5001.webp",
      "/images/holic/group04/3018.webp",
      "/images/holic/group01/1018.webp",
      "/images/holic/group01/1019.webp",
      "/images/holic/group01/1023.webp",
      "/images/holic/group01/1071.webp",
      "/images/holic/group01/1021.webp",
      "/images/holic/group01/1036.webp",
      "/images/holic/group01/1082.webp",
      "/images/holic/group01/1034.webp",
      "/images/holic/group03/1517.webp",
      "/images/holic/group01/1017.webp",
      "/images/holic/group02/1101.webp",
      "/images/holic/group01/1035.webp",
      "/images/holic/group02/1113.webp",
      "/images/holic/group04/3200.webp",
      "/images/holic/group01/1029.webp",
      "/images/holic/group02/1111.webp",
      "/images/holic/group01/1043.webp",
      "/images/holic/group04/2042.webp",
      "/images/holic/group01/1003.webp",
      "/images/holic/group05/7777.webp",
      "/images/holic/group01/1079.webp",
      "/images/holic/group01/1070.webp",
      "/images/holic/group01/1026.webp",
      "/images/holic/group03/1500.webp",
      "/images/holic/group03/1818.webp",
      "/images/holic/group01/1024.webp",
      "/images/holic/group02/1105.webp",
      "/images/holic/group01/1005.webp",
      "/images/holic/group01/1080.webp",
      "/images/holic/group01/1020.webp",
      "/images/holic/group02/1108.webp",
      "/images/holic/group01/1015.webp",
      "/images/holic/group01/1011.webp",
      "/images/holic/group01/1016.webp",
      "/images/holic/group04/3132.webp",
      "/images/holic/group01/1037.webp",
      "/images/holic/group01/1047.webp",
      "/images/holic/group05/7000.webp",
      "/images/holic/group03/1314.webp",
      "/images/holic/group02/1106.webp",
      "/images/holic/group01/1041.webp",
      "/images/holic/group05/5000.webp",
      "/images/holic/group01/1028.webp",
      "/images/holic/group05/8888.webp",
      "/images/holic/group01/1009.webp",
      "/images/holic/group04/3000.webp",
      "/images/holic/group01/1025.webp",
      "/images/holic/group05/7788.webp",
      "/images/holic/group04/2222.webp",
      "/images/holic/group01/1046.webp",
      "/images/holic/group01/1014.webp",
      "/images/holic/group01/1076.webp",
      "/images/holic/group01/1030.webp",
      "/images/holic/group01/1006.webp",
      "/images/holic/group01/1027.webp",
      "/images/holic/group01/1002.webp",
      "/images/holic/group01/1077.webp",
      "/images/holic/group02/1104.webp",
      "/images/holic/group01/1010.webp",
      "/images/holic/group04/3333.webp",
      "/images/holic/group02/1100.webp",
      "/images/holic/group01/1078.webp",
      "/images/holic/group01/1081.webp",
      "/images/holic/group01/1031.webp",
      "/images/holic/group01/1004.webp",
      "/images/holic/group01/1083.webp",
      "/images/holic/group01/1075.webp",
      "/images/holic/group03/1516.webp",
      "/images/holic/group04/2828.webp",
      "/images/holic/group01/1038.webp",
      "/images/holic/group02/1112.webp",
      "/images/holic/group01/1074.webp",
      "/images/holic/group01/1042.webp",
      "/images/holic/group02/1107.webp",
      "/images/holic/group01/1008.webp",
      "/images/holic/group01/1045.webp",
      "/images/holic/group01/1033.webp",
      "/images/holic/group01/1048.webp",
      "/images/holic/group01/1000.webp",
      "/images/holic/group01/1039.webp",
      "/images/holic/group02/1103.webp",
      "/images/holic/group04/2000.webp",
      "/images/holic/group02/1102.webp",
      "/images/holic/group01/1022.webp",
      "/images/holic/group02/1109.webp"
    ],
    "isSpecial": false
  },
  {
    "id": 33,
    "amount": 50000,
    "frontImages": [
      "/images/holic/group06/10062.webp",
      "/images/holic/group06/10104.webp",
      "/images/holic/group06/10152.webp",
      "/images/holic/group06/10108.webp",
      "/images/holic/group06/10182.webp",
      "/images/holic/group06/10004.webp",
      "/images/holic/group06/10112.webp",
      "/images/holic/group06/12486.webp",
      "/images/holic/group06/10113.webp",
      "/images/holic/group06/10018.webp",
      "/images/holic/group06/10109.webp",
      "/images/holic/group06/10003.webp",
      "/images/holic/group06/10000.webp",
      "/images/holic/group06/10118.webp",
      "/images/holic/group06/10186.webp",
      "/images/holic/group06/10005.webp",
      "/images/holic/group06/10138.webp",
      "/images/holic/group06/10160.webp",
      "/images/holic/group06/10100.webp",
      "/images/holic/group06/10101.webp"
    ],
    "isSpecial": true
  }
];

export const queendomNormalMessages = [
  {
    "text": "화장실\n1개",
    "color": "#ffffff",
    "bgColor": "#4a5568",
    "weight": 0
  },
  {
    "text": "레전드 ✨",
    "color": "#1f2937",
    "bgColor": "#fcd34d",
    "weight": 0
  },
  {
    "text": "기여도\n두배",
    "color": "#ffffff",
    "bgColor": "#6366f1",
    "weight": 60
  },
  {
    "text": "기여도\n세배",
    "color": "#ffffff",
    "bgColor": "#7c3aed",
    "weight": 30
  },
  {
    "text": "기여도\n네배",
    "color": "#ffffff",
    "bgColor": "#9333ea",
    "weight": 5
  },
  {
    "text": "1000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "#fbbf24",
    "weight": 0
  },
  {
    "text": "전설 🏆",
    "color": "#ffffff",
    "bgColor": "#f97316",
    "weight": 0
  },
  {
    "text": "10000\n원당첨!",
    "color": "#ffffff",
    "bgColor": "#ef4444",
    "weight": 0
  },
  {
    "text": "퇴근!🏠",
    "color": "#ffffff",
    "bgColor": "#ec4899",
    "weight": 0
  },
  {
    "text": "꽝 🤡",
    "color": "#ffffff",
    "bgColor": "#1f2937",
    "weight": 5
  }
];
export const queendomSpecialMessages = [
  {
    "text": "기여도 두배 🎁",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #6366f1, #8b5cf6)",
    "weight": 60
  },
  {
    "text": "기여도 세배 🌟",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #7c3aed, #ec4899)",
    "weight": 35
  },
  {
    "text": "기여도 네배 🔥",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #f97316, #ef4444)",
    "weight": 5
  },
  {
    "text": "💰 30,000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "linear-gradient(90deg, #fde68a, #fbbf24)",
    "weight": 0
  },
  {
    "text": "💎 50,000원\n당첨!",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #38bdf8, #6366f1)",
    "weight": 0
  },
  {
    "text": "🎊 100,000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "linear-gradient(90deg, #facc15, #f97316)",
    "weight": 0
  },
  {
    "text": "퇴근 🏠",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #ef4444, #ec4899)",
    "weight": 0
  },
  {
    "text": "화장실 무제한 ♾️",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #60a5fa, #3b82f6)",
    "weight": 0
  },
  {
    "text": "레전드 💠",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #a78bfa, #7c3aed)",
    "weight": 0
  },
  {
    "text": "전설 🔱",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #f472b6, #ec4899)",
    "weight": 0
  }
];

export const museNormalMessages = [
  {
    "text": "화장실\n1개",
    "color": "#ffffff",
    "bgColor": "#4a5568",
    "weight": 0
  },
  {
    "text": "레전드 ✨",
    "color": "#1f2937",
    "bgColor": "#fcd34d",
    "weight": 0
  },
  {
    "text": "기여도\n두배",
    "color": "#ffffff",
    "bgColor": "#6366f1",
    "weight": 60
  },
  {
    "text": "기여도\n세배",
    "color": "#ffffff",
    "bgColor": "#7c3aed",
    "weight": 30
  },
  {
    "text": "기여도\n네배",
    "color": "#ffffff",
    "bgColor": "#9333ea",
    "weight": 5
  },
  {
    "text": "1000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "#fbbf24",
    "weight": 0
  },
  {
    "text": "전설 🏆",
    "color": "#ffffff",
    "bgColor": "#f97316",
    "weight": 0
  },
  {
    "text": "10000\n원당첨!",
    "color": "#ffffff",
    "bgColor": "#ef4444",
    "weight": 0
  },
  {
    "text": "퇴근!🏠",
    "color": "#ffffff",
    "bgColor": "#ec4899",
    "weight": 0
  },
  {
    "text": "꽝 🤡",
    "color": "#ffffff",
    "bgColor": "#1f2937",
    "weight": 5
  }
];
export const museSpecialMessages = [
  {
    "text": "기여도 두배 🎁",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #6366f1, #8b5cf6)",
    "weight": 60
  },
  {
    "text": "기여도 세배 🌟",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #7c3aed, #ec4899)",
    "weight": 35
  },
  {
    "text": "기여도 네배 🔥",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #f97316, #ef4444)",
    "weight": 5
  },
  {
    "text": "💰 30,000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "linear-gradient(90deg, #fde68a, #fbbf24)",
    "weight": 0
  },
  {
    "text": "💎 50,000원\n당첨!",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #38bdf8, #6366f1)",
    "weight": 0
  },
  {
    "text": "🎊 100,000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "linear-gradient(90deg, #facc15, #f97316)",
    "weight": 0
  },
  {
    "text": "퇴근 🏠",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #ef4444, #ec4899)",
    "weight": 0
  },
  {
    "text": "화장실 무제한 ♾️",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #60a5fa, #3b82f6)",
    "weight": 0
  },
  {
    "text": "레전드 💠",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #a78bfa, #7c3aed)",
    "weight": 0
  },
  {
    "text": "전설 🔱",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #f472b6, #ec4899)",
    "weight": 0
  }
];

export const holicNormalMessages = [
  {
    "text": "화장실\n1개",
    "color": "#ffffff",
    "bgColor": "#4a5568",
    "weight": 0
  },
  {
    "text": "레전드 ✨",
    "color": "#1f2937",
    "bgColor": "#fcd34d",
    "weight": 0
  },
  {
    "text": "기여도\n두배",
    "color": "#ffffff",
    "bgColor": "#6366f1",
    "weight": 60
  },
  {
    "text": "기여도\n세배",
    "color": "#ffffff",
    "bgColor": "#7c3aed",
    "weight": 30
  },
  {
    "text": "기여도\n네배",
    "color": "#ffffff",
    "bgColor": "#9333ea",
    "weight": 5
  },
  {
    "text": "1000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "#fbbf24",
    "weight": 0
  },
  {
    "text": "전설 🏆",
    "color": "#ffffff",
    "bgColor": "#f97316",
    "weight": 0
  },
  {
    "text": "10000\n원당첨!",
    "color": "#ffffff",
    "bgColor": "#ef4444",
    "weight": 0
  },
  {
    "text": "퇴근!🏠",
    "color": "#ffffff",
    "bgColor": "#ec4899",
    "weight": 0
  },
  {
    "text": "꽝 🤡",
    "color": "#ffffff",
    "bgColor": "#1f2937",
    "weight": 5
  }
];
export const holicSpecialMessages = [
  {
    "text": "기여도 두배 🎁",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #6366f1, #8b5cf6)",
    "weight": 60
  },
  {
    "text": "기여도 세배 🌟",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #7c3aed, #ec4899)",
    "weight": 35
  },
  {
    "text": "기여도 네배 🔥",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #f97316, #ef4444)",
    "weight": 5
  },
  {
    "text": "💰 30,000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "linear-gradient(90deg, #fde68a, #fbbf24)",
    "weight": 0
  },
  {
    "text": "💎 50,000원\n당첨!",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #38bdf8, #6366f1)",
    "weight": 0
  },
  {
    "text": "🎊 100,000원\n당첨!",
    "color": "#1f2937",
    "bgColor": "linear-gradient(90deg, #facc15, #f97316)",
    "weight": 0
  },
  {
    "text": "퇴근 🏠",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #ef4444, #ec4899)",
    "weight": 0
  },
  {
    "text": "화장실 무제한 ♾️",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #60a5fa, #3b82f6)",
    "weight": 0
  },
  {
    "text": "레전드 💠",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #a78bfa, #7c3aed)",
    "weight": 0
  },
  {
    "text": "전설 🔱",
    "color": "#ffffff",
    "bgColor": "linear-gradient(90deg, #f472b6, #ec4899)",
    "weight": 0
  }
];
